import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atBottomCenterphs4xo2ro2dv as get_atBottomCenter,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq as ProjectState_AwaitingFunding_getInstance,
  ProjectState_InProgress_getInstance2qplvnabv8loq as ProjectState_InProgress_getInstance,
  ProjectState_Accepted_getInstance2l1kftynf92aa as ProjectState_Accepted_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  specCenteredTextWithUnread1yfsy2lami2hh as specCenteredTextWithUnread,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_dangerButtonciwpmvl7jmt2 as get_dangerButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { isProjectLocked21m24mmy2in1h as isProjectLocked } from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
} from '../../../../screens/common/ProjectView.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../../../theming/appTheme.mjs';
import {
  title1nssp3ryhwuqj as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  body3i5t0n7zprpqb as body,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
} from '../../../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
  timesx4ey3un7ihw1 as times,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../../../nav/crowpay.mjs';
import {
  plus310ted5e4i90h as plus,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  asSequence2phdjljfh9jhx as asSequence,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { forEachWithRenderer12ybmdeyp3omm as forEachWithRenderer } from '../../../forEachWithRenderer.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  DrawTableItemvon7hn1chfhu as DrawTableItem,
  Creditv1m3yq08fl3i as Credit,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__times_impl_hlr6p72nff9ykdm2zvo as MonetaryValue__times_impl_hlr6p7,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  getPaymentData33dmvsrmw11t5 as getPaymentData,
  get_status1qu684t7g7eh as get_status,
  overallStatus206eg9g5yqouc as overallStatus,
  PayAppStatus_Pending_getInstance2ma8qo3my1dmm as PayAppStatus_Pending_getInstance,
  PayAppStatus_Draft_getInstance171ihe7xpmy9q as PayAppStatus_Draft_getInstance,
  PayAppStatus_Denied_getInstance3qemqfv8kyvuv as PayAppStatus_Denied_getInstance,
  PayAppStatus_Approved_getInstance1spuu4f2mfbic as PayAppStatus_Approved_getInstance,
} from './data.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { renderPayAppCard339rz4b2yqqq1 as renderPayAppCard } from './cards.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  PayApplicationmbkdcq3ut87x as PayApplication,
  Incident3aojs8cp7629c as Incident,
  LineItem2rt64afaiyloc as LineItem,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { RecyclerViewRendererSet341fhovxcnndi as RecyclerViewRendererSet } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/RecyclerViewRendererSet.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_session9cytjmfbg8nd as get_session,
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  lensUnread1tcpdysie4g78 as lensUnread,
} from '../../../../../sdk/UserSession.mjs';
import {
  isUnread2u0ehyt0ioouz as isUnread,
  handleOne3ny7r4k654tcd as handleOne,
} from '../../../../../extensions/HasReadBy.ext.mjs';
import {
  unreadIconWhen1430ixd91bo9h as unreadIconWhen,
  actionIcon360epyywhabwj as actionIcon,
  scopeSetIcon1d64me82i5zfn as scopeSetIcon,
} from '../../../iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic,
  GreyedOutSemantic_getInstancexltt5xem3a07 as GreyedOutSemantic_getInstance,
} from '../../../../theming/states.mjs';
import {
  Companion_getInstance3052zauf3vwf2 as Companion_getInstance_1,
  CreditDetails2g0vi8qhuk0sb as CreditDetails,
  DrawWaitedDetails301fxrq4n3zo5 as DrawWaitedDetails,
} from '../../../../dialogs/BasicFlowForms.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import {
  get_lightSection4cpu8okr0w14 as get_lightSection,
  SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance,
} from '../../../../theming/sections.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { toList2zksu85ukrmi as toList_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  Companion_getInstance1350ksylxva5s as Companion_getInstance_2,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  plus354lvypr4cqa1 as plus_0,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { leftExpandButtonWithUnread1gpbgdpec45fr as leftExpandButtonWithUnread } from '../../../expansion.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  PayAppForm28kp0pq290pd9 as PayAppForm,
  CreatePayApp1rwu0bqbguotz as CreatePayApp,
} from './PayAppForm.mjs';
import {
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../../../icons.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
  space2ppi73m2qk1br as space,
} from '../../../space.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { label287uhiq3m9m4z as label2 } from '../../../label2.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../../files/renderFiles.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { mapNotNull3b8ce5hky4k2l as mapNotNull } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { containsDynamic2l3li0bgncl7n as containsDynamic } from '../../../Multiselect.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  ForegroundSemantic2og103ajpnjfv as ForegroundSemantic,
  colored3y8uibz1hk46 as colored,
} from '../../../../theming/colorManagement.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance_3 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { trackWeights2d4yjn3jzod5x as trackWeights } from '../../../../../utils/tables/ColumnWeights.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Companion_instance2o1tmep3w0ant as Companion_instance_0 } from '../../activity/concerns/IncidentReportForm.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Companion_instance3euo5q27joywz as Companion_instance_1 } from '../scope/LineItemCompletionForm.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  AddProjectCreditDialog2vna8ff6u799p as AddProjectCreditDialog,
  AddWorkItemCreditDialog1hq298k1vgsaa as AddWorkItemCreditDialog,
} from '../../../../dialogs/CreditDialogs.mjs';
import { RadioButton1rpamcjl5aybg as RadioButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  get_pageNavigator1inl9j7ja0vlf as get_pageNavigator,
  get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { PayAppSummary1iyji3gt9nfm0 as PayAppSummary } from './PayAppSummary.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../../../dialogs/GenericConfirmationDialog.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../utils/JumpTo.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { WaitDrawsDialog11kr3h4lqhbji as WaitDrawsDialog } from '../../../../dialogs/PagedUserTextInputDialog.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_rowHeight() {
  _init_properties_payAppsTab_kt__q3ukvv();
  return rowHeight;
}
var rowHeight;
function draws(_this__u8e3s4, writer) {
  _init_properties_payAppsTab_kt__q3ukvv();
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  if (_this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance())) {
    var tmp = get_atTopEnd(view);
    var tmp_0 = view.ibb(tmp, shownWhen(view, VOID, ($this$shownWhen) => {
      var tmp0_elvis_lhs = $this$shownWhen.baj(_this__u8e3s4.pgj_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      return tmp.d4(MemberRole_Manager_getInstance()) >= 0;
    }));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    var tmp_1 = view_0.ibb(shownWhen(view_0, VOID, draws$lambda), get_tertiaryButton(view_0));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    var tmp_2 = KMutableProperty0();
    var tmp_3 = Button$_get_enabled_$ref_61t7nx(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, Button$_set_enabled_$ref_o8kynz(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp;
      if (!isProjectLocked($this$reactiveScope.baj(_this__u8e3s4.agj_1)) && $this$reactiveScope.baj(_this__u8e3s4.agj_1).d4(ProjectState_AwaitingFunding_getInstance()) >= 0) {
        var tmp0 = $this$reactiveScope.baj(_this__u8e3s4.tgm());
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.i1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.hf9_1.w91()) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        tmp = false;
      }
      var tmp$ret$2 = tmp;
      this_0.set(tmp$ret$2);
      return Unit_instance;
    });
    specCenteredText(view_1, '+ Credit');
    onClick(view_1, 'Add Credit', VOID, draws$slambda_0(_this__u8e3s4));
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_1, view_1);
    var tmp_4 = get_tertiaryButton(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.ebb(p_2, view_2);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = Button$_get_enabled_$ref_61t7nx_1(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('enabled', 0, tmp_5, tmp_6, Button$_set_enabled_$ref_o8kynz_1(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$7 = !isProjectLocked($this$reactiveScope.baj(_this__u8e3s4.agj_1)) && $this$reactiveScope.baj(_this__u8e3s4.agj_1).d4(ProjectState_InProgress_getInstance()) >= 0;
      this_1.set(tmp$ret$7);
      return Unit_instance;
    });
    specCenteredText_0(view_2, ($this$specCenteredText) => {
      var tmp;
      var tmp0 = $this$specCenteredText.baj(_this__u8e3s4.dgt());
      var tmp$ret$9;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.i1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$9 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.m6y_1 == null) {
            tmp$ret$9 = true;
            break $l$block_2;
          }
        }
        tmp$ret$9 = false;
      }
      if (tmp$ret$9) {
        tmp = 'Edit Draft';
      } else {
        tmp = '+ Draw';
      }
      return tmp;
    });
    onClick(view_2, 'Create new Draw', VOID, draws$slambda_2(_this__u8e3s4, view_2));
    view_0.fbb(p_2, view_2);
    view_0.jbb(tmp_4, view_2);
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
  }
  var workItemCredits = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = $this$remember.baj(_this__u8e3s4.tgm());
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      // Inline function 'kotlin.collections.filter' call
      var tmp0_0 = element.hf9_1.x6k_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList().w();
      var _iterator__ex2g4s_0 = tmp0_0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (element_0.c5r_1 == null && element_0.d5r_1 == null && element_0.e5r_1 == null) {
          destination_0.v(element_0);
        }
      }
      var list = destination_0;
      addAll(destination, list);
    }
    return destination;
  });
  var tmp_7 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(15));
  var tmp_8 = view.ibb(tmp_7, shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp;
    if (_this__u8e3s4.rgj().xgj()) {
      // Inline function 'kotlin.let' call
      var it = $this$shownWhen.baj(_this__u8e3s4.dgt());
      var tmp_0;
      if (it.i1()) {
        tmp_0 = true;
      } else {
        var tmp$ret$24;
        $l$block_4: {
          // Inline function 'kotlin.collections.all' call
          var tmp_1;
          if (isInterface(it, Collection())) {
            tmp_1 = it.i1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$24 = true;
            break $l$block_4;
          }
          var _iterator__ex2g4s = it.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!(element.m6y_1 == null)) {
              tmp$ret$24 = false;
              break $l$block_4;
            }
          }
          tmp$ret$24 = true;
        }
        tmp_0 = tmp$ret$24;
      }
      tmp = tmp_0;
    } else {
      tmp = $this$shownWhen.baj(_this__u8e3s4.dgt()).i1();
    }
    var noDraws = tmp;
    return noDraws && $this$shownWhen.baj(_this__u8e3s4.jfy()).z7b_1.i1() && $this$shownWhen.baj(workItemCredits).i1();
  }));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  var tmp_9 = view_3.ibb(get_centered(view_3), view_3.hbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_4.xbm(true);
  view_4.jbb(get_centered(view_4), title(view_4, 'Nothing Yet'));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
  view_5.bbs(Align_Center_getInstance());
  var tmp_10 = KMutableProperty0();
  var tmp_11 = TextView$_get_content_$ref_4pzcwl(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$28 = $this$reactiveScope.baj(_this__u8e3s4.agj_1).d4(ProjectState_Accepted_getInstance()) < 0 ? 'This info will be available once the project is In Progress.' : _this__u8e3s4.rgj().xgj() ? 'When partial payment for completed work is requested it will appear here.' : 'When partial payment for completed work is requested it will appear here. Press "+ Draw" to create a Draw.';
    this_2.set(tmp$ret$28);
    return Unit_instance;
  });
  view_4.fbb(p_5, view_5);
  view_3.fbb(p_4, view_4);
  view_3.jbb(tmp_9, view_4);
  view.fbb(p_3, view_3);
  view.jbb(tmp_8, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_6 = view.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.ebb(p_6, view_6);
  view_6.xbm(true);
  if (get_viewIsWide(view_6)) {
    view_6.dba(get_dp(0));
  }
  var renderers = new (DrawTableRenderer())(_this__u8e3s4);
  var tmp_12 = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = plus(plus($this$remember.baj(_this__u8e3s4.dgt()), $this$remember.baj(_this__u8e3s4.jfy()).z7b_1), $this$remember.baj(workItemCredits));
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = draws$lambda$lambda;
    var tmp$ret$42 = new (sam$kotlin_Comparator$0())(tmp);
    return sortedWith(this_0, tmp$ret$42);
  });
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList().u(5);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < 5)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$44 = renderers.ghj_1;
      list.v(tmp$ret$44);
    }
     while (inductionVariable < 5);
  forEachWithRenderer(view_6, tmp_12, renderers, list);
  view.fbb(p_6, view_6);
  writer.fbb(p, view);
  return view;
}
var CreditKind_Project_instance;
var CreditKind_WorkItem_instance;
function values() {
  return [CreditKind_Project_getInstance(), CreditKind_WorkItem_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CreditKind_entriesInitialized;
function CreditKind_initEntries() {
  if (CreditKind_entriesInitialized)
    return Unit_instance;
  CreditKind_entriesInitialized = true;
  CreditKind_Project_instance = CreditKind().mhj('Project', 0, 'Project', 'Issue a credit to the entire project. Will reduce the price of all work items proportionally to their outstanding balance.');
  CreditKind_WorkItem_instance = CreditKind().mhj('WorkItem', 1, 'Work Item', 'Issue a credit to a specific work item.');
}
var $ENTRIES;
var CreditKindClass;
function CreditKind() {
  if (CreditKindClass === VOID) {
    class $ extends Enum() {
      static mhj(name, ordinal, displayName, description) {
        var $this = this.c4(name, ordinal);
        $this.khj_1 = displayName;
        $this.lhj_1 = description;
        return $this;
      }
      g90() {
        return this.khj_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'CreditKind', VOID, VOID, [HasDisplayName(), Enum()]);
    CreditKindClass = $;
  }
  return CreditKindClass;
}
function paymentData($this, item) {
  var tmp0 = $this.fhj_1;
  // Inline function 'kotlin.collections.getOrPut' call
  var key = item.i6y_1;
  var value = tmp0.p3(key);
  var tmp;
  if (value == null) {
    var answer = remember(VOID, VOID, VOID, ($this$remember) => getPaymentData($this$remember, $this.ehj_1, item));
    tmp0.s3(key, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
var DrawTableRenderer$payAppRenderer$1Class;
function DrawTableRenderer$payAppRenderer$1() {
  if (DrawTableRenderer$payAppRenderer$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.nhj_1 = this$0;
      }
      ohj(viewWriter, data, index) {
        // Inline function 'kotlin.with' call
        var $this$with = this.nhj_1.ehj_1;
        if (!isInterface(data, Reactive()))
          THROW_CCE();
        var paymentData_0 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(paymentData(this.nhj_1, $this$remember.baj(data))));
        return get_viewIsNarrow(viewWriter) ? renderPayAppCard($this$with, data, paymentData_0, viewWriter) : renderPayApp2($this$with, data, paymentData_0, viewWriter);
      }
      ndg(viewWriter, data, index) {
        return this.ohj(viewWriter, data, index);
      }
    }
    initMetadataForClass($);
    DrawTableRenderer$payAppRenderer$1Class = $;
  }
  return DrawTableRenderer$payAppRenderer$1Class;
}
var DrawTableRenderer$creditRenderer$1Class;
function DrawTableRenderer$creditRenderer$1() {
  if (DrawTableRenderer$creditRenderer$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.phj_1 = this$0;
      }
      ohj(viewWriter, data, index) {
        // Inline function 'kotlin.with' call
        var $this$with = this.phj_1.ehj_1;
        if (!isInterface(data, Reactive()))
          THROW_CCE();
        return renderCredit($this$with, data, viewWriter);
      }
      ndg(viewWriter, data, index) {
        return this.ohj(viewWriter, data, index);
      }
    }
    initMetadataForClass($);
    DrawTableRenderer$creditRenderer$1Class = $;
  }
  return DrawTableRenderer$creditRenderer$1Class;
}
var DrawTableRendererClass;
function DrawTableRenderer() {
  if (DrawTableRendererClass === VOID) {
    class $ {
      constructor(projectView) {
        this.ehj_1 = projectView;
        this.fhj_1 = HashMap().n8();
        var tmp = this;
        tmp.ghj_1 = new (DrawTableRenderer$payAppRenderer$1())(this);
        var tmp_0 = this;
        tmp_0.hhj_1 = new (DrawTableRenderer$creditRenderer$1())(this);
      }
      qhj(item) {
        return item.b95();
      }
      idg(item) {
        return this.qhj((!(item == null) ? isInterface(item, DrawTableItem()) : false) ? item : THROW_CCE());
      }
      rhj(item) {
        var tmp;
        if (item instanceof Credit()) {
          tmp = this.hhj_1;
        } else {
          if (item instanceof PayApplication()) {
            tmp = this.ghj_1;
          } else {
            noWhenBranchMatchedException();
          }
        }
        return tmp;
      }
      hdg(item) {
        return this.rhj((!(item == null) ? isInterface(item, DrawTableItem()) : false) ? item : THROW_CCE());
      }
    }
    initMetadataForClass($, 'DrawTableRenderer', VOID, VOID, [RecyclerViewRendererSet()]);
    DrawTableRendererClass = $;
  }
  return DrawTableRendererClass;
}
function renderCredit(_this__u8e3s4, credit, writer) {
  _init_properties_payAppsTab_kt__q3ukvv();
  // Inline function 'kotlin.with' call
  var workItem = remember(VOID, VOID, VOID, ($this$remember) => {
    var c = $this$remember.baj(credit);
    var tmp;
    if (!(c.e5r_1 == null)) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp0 = $this$remember.baj(_this__u8e3s4.tgm());
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.hf9_1.x6k_1.t1(c)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp0_safe_receiver = tmp$ret$1;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hf9_1;
    }
    return tmp;
  });
  var label = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp0_safe_receiver = $this$remember.baj(workItem);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = 'Credit: ' + tmp0_safe_receiver.u91();
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp2_elvis_lhs = $this$remember.baj(credit).e5r_1;
      tmp_0 = 'Project Credit ' + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  });
  var tmp;
  if (get_viewIsNarrow(writer)) {
    var tmp_0 = get_lightSection(writer);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Button())(writer.pc());
    var tmp0_elvis_lhs = writer.cbb_1;
    var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
    writer.ebb(p, view);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    var tmp_1 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.boldSubTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance().ybe(BoldSemantic_getInstance())));
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl_0(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_0(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$5 = $this$reactiveScope.baj(label);
      this_0.set(tmp$ret$5);
      return Unit_instance;
    });
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_1, view_1);
    var tmp_4 = view_0.ibb(get_expanding(view_0), get_centered(view_0));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl_1(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_1(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$12 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.baj(credit).a5r_1);
      this_1.set(tmp$ret$12);
      return Unit_instance;
    });
    view_0.fbb(p_2, view_2);
    view_0.jbb(tmp_4, view_2);
    view_0.jbb(view_0.ibb(get_centered(view_0), view_0.hbb(DisplayableStateSemantic().mgt(Companion_getInstance_1().shj_1))), body(view_0, Companion_getInstance_1().shj_1.vgo_1));
    view.fbb(p_0, view_0);
    onClick(view, 'View Details', VOID, renderCredit$slambda_0(view, credit, _this__u8e3s4, workItem));
    writer.fbb(p, view);
    tmp = writer.jbb(tmp_0, view);
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(writer.pc());
    var tmp0_elvis_lhs_3 = writer.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? writer : tmp0_elvis_lhs_3;
    writer.ebb(p_3, view_3);
    view_3.xbm(true);
    view_3.zb8(get_px(0));
    var tmp_7 = sizeConstraints(view_3, VOID, VOID, VOID, VOID, VOID, VOID, get_rowHeight());
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.xbm(false);
    view_4.zb8(get_rem_0(0.5));
    view_4.hba(Edges().ad0(get_px(0)).gd0(get_rem_0(0.5), VOID, view_4.kba().hb0_1));
    if (get_viewIsWide(view_4)) {
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Space())(view_4.pc(), 1.0);
      var tmp0_elvis_lhs_5 = view_4.cbb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
      view_4.ebb(p_5, view_5);
      view_4.fbb(p_5, view_5);
    }
    var tmp_8 = view_4.ibb(get_expanding(view_4), get_compact(view_4));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_6 = view_4.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
    view_4.ebb(p_6, view_6);
    view_6.xbm(false);
    get_centered(view_6);
    unreadIconWhen(view_6, ($this$unreadIconWhen) => isUnread($this$unreadIconWhen.baj(credit), $this$unreadIconWhen.baj(get_session()).efv_1));
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance_0();
    var tmp_9 = get_centered(view_6);
    // Inline function 'com.crowpay.views.theming.subTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (TextView())(view_6.pc());
    var tmp0_elvis_lhs_7 = view_6.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
    view_6.ebb(p_7, view_7);
    view_7.jba(view_7.ob6_1.ybe(SubtitleSemantic_getInstance()));
    var tmp_10 = KMutableProperty0();
    var tmp_11 = TextView$_get_content_$ref_4pzcwl_2(view_7);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb_2(view_7));
    reactiveScope(view_7, ($this$reactiveScope) => {
      var tmp$ret$30 = $this$reactiveScope.baj(label);
      this_2.set(tmp$ret$30);
      return Unit_instance;
    });
    view_6.fbb(p_7, view_7);
    view_6.jbb(tmp_9, view_7);
    view_6.jbb(view_6.ibb(get_centered(view_6), view_6.hbb(DisplayableStateSemantic().mgt(Companion_getInstance_1().shj_1))), body(view_6, Companion_getInstance_1().shj_1.vgo_1));
    view_4.fbb(p_6, view_6);
    view_4.jbb(tmp_8, view_6);
    var tmp_12 = view_4.ibb(get_centered(view_4), get_secondaryButton(view_4));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Button())(view_4.pc());
    var tmp0_elvis_lhs_8 = view_4.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
    view_4.ebb(p_8, view_8);
    specCenteredText(view_8, 'View Details');
    view_8.eba(get_dp(5));
    onClick(view_8, 'View Details', VOID, renderCredit$slambda_2(credit, _this__u8e3s4, workItem));
    view_4.fbb(p_8, view_8);
    view_4.jbb(tmp_12, view_8);
    view_3.fbb(p_4, view_4);
    view_3.jbb(tmp_7, view_4);
    greySeparator(view_3);
    writer.fbb(p_3, view_3);
    tmp = view_3;
  }
  return tmp;
}
function renderPayApp2(_this__u8e3s4, payApp, items, writer) {
  _init_properties_payAppsTab_kt__q3ukvv();
  // Inline function 'kotlin.with' call
  var expanded = Signal().fak(false);
  var status = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this$remember.baj(items);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = element.shc_1;
      var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver_0);
      }
    }
    return overallStatus(toSet(destination));
  });
  var pending = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(items);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = element.shc_1;
      if (equals(tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver), PayAppStatus_Pending_getInstance())) {
        destination.v(element);
      }
    }
    return destination;
  });
  var groupedItems = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = $this$remember.baj(_this__u8e3s4.lgy());
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap().fc(capacity);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp$ret$10 = element.k7z_1;
      destination.s3(tmp$ret$10, element);
    }
    var scopes = destination;
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0 = $this$remember.baj(items);
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_0 = LinkedHashMap().f6();
    var _iterator__ex2g4s_0 = tmp0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      var key = element_0.rhc_1.nfy();
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_0.p3(key);
      var tmp;
      if (value == null) {
        var answer = ArrayList().w();
        destination_0.s3(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.v(element_0);
    }
    // Inline function 'kotlin.collections.mapKeys' call
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination_1 = LinkedHashMap().fc(mapCapacity(destination_0.p1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_1 = destination_0.d2().m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_1 = _iterator__ex2g4s_1.o1();
      // Inline function 'kotlin.collections.component1' call
      var id = element_1.e2();
      // Inline function 'kotlin.collections.get' call
      var tmp_0 = (isInterface(scopes, KtMap()) ? scopes : THROW_CCE()).p3(id);
      var tmp$ret$21 = element_1.f2();
      destination_1.s3(tmp_0, tmp$ret$21);
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_1 = toList_0(destination_1);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = renderPayApp2$lambda$lambda;
    var tmp$ret$25 = new (sam$kotlin_Comparator$0_0())(tmp_1);
    return sortedWith(this_1, tmp$ret$25);
  });
  // Inline function 'kotlin.collections.setOf' call
  var tmp$ret$27 = emptySet();
  var selectedItems = Signal().fak(tmp$ret$27);
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(selectedItems).p1() === $this$remember.baj(pending).p1());
  var allSelected = withWrite(tmp, renderPayApp2$slambda_0(selectedItems, pending));
  var labelValue = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this$remember.baj(selectedItems).p1() === $this$remember.baj(pending).p1()) {
      tmp = ' All';
    } else if ($this$remember.baj(selectedItems).p1() > 1 && $this$remember.baj(selectedItems).p1() < $this$remember.baj(pending).p1()) {
      tmp = ' (' + $this$remember.baj(selectedItems).p1() + ')';
    } else {
      tmp = '';
    }
    return tmp;
  });
  var tmp_0 = get_rawSession();
  var payAppIsUnread = lensUnread(tmp_0, (session) => handleOne(session.afw_1, ($this$handleOne, it) => $this$handleOne.baj(payApp)));
  var tmp_1 = get_rawSession();
  var feedbackUnread = lensUnread(tmp_1, (session) => session.bfw_1.wft(VOID, ($this$feedbackIsUnread, it) => {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this$feedbackIsUnread.baj(items);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = element.shc_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver);
      }
    }
    return destination;
  }));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  view.zb8(get_rem(0));
  var tmp_2 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rowHeight());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.hba(Edges().ad0(get_px(0)).gd0(VOID, VOID, view_0.kba().hb0_1));
  dynamicTheme(view_0, ($this$dynamicTheme) => {
    var tmp;
    if ($this$dynamicTheme.baj(expanded)) {
      // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
      Companion_getInstance_2();
      tmp = new (_no_name_provided__qut3iv())();
    } else {
      tmp = null;
    }
    return tmp;
  });
  var tmp_3 = get_expanding(view_0);
  var tmp_4 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(payAppIsUnread).sfw($this$remember.baj(feedbackUnread)));
  view_0.jbb(tmp_3, leftExpandButtonWithUnread(view_0, expanded, tmp_4, false, VOID, ($this$leftExpandButtonWithUnread) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$leftExpandButtonWithUnread.pc());
    var tmp0_elvis_lhs = $this$leftExpandButtonWithUnread.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$leftExpandButtonWithUnread : tmp0_elvis_lhs;
    $this$leftExpandButtonWithUnread.ebb(p, view);
    view.xbm(false);
    view.zb8(get_dp(8));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(get_AppDimensions().mg2_1);
    var tmp = get_centered(view_0);
    view_0.jbb(tmp, actionIcon(view_0, VOID, ($this$actionIcon) => {
      var tmp;
      var tmp_0;
      if (_this__u8e3s4.rgj().xgj()) {
        var tmp0 = $this$actionIcon.baj(items);
        var tmp$ret$36;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(tmp0, Collection())) {
            tmp_1 = tmp0.i1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$36 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.shc_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b6w_1) === true) {
              tmp$ret$36 = true;
              break $l$block_0;
            }
          }
          tmp$ret$36 = false;
        }
        tmp_0 = tmp$ret$36;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = ActionImportance_Important_getInstance();
      } else {
        tmp = null;
      }
      return tmp;
    }));
    var tmp_0 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.subTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_3(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_3(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$38 = 'Draw ' + $this$reactiveScope.baj(payApp).k6y_1;
      this_0.set(tmp$ret$38);
      return Unit_instance;
    });
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_0, view_1);
    view.fbb(p_0, view_0);
    var tmp_3 = get_centered(view);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_4 = KMutableProperty0();
    var tmp_5 = TextView$_get_content_$ref_4pzcwl_4(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_4(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$49 = $this$reactiveScope.baj(status).vhf_1;
      this_1.set(tmp$ret$49);
      return Unit_instance;
    });
    dynamicTheme(view_2, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(status)));
    view.fbb(p_2, view_2);
    view.jbb(tmp_3, view_2);
    $this$leftExpandButtonWithUnread.fbb(p, view);
    return Unit_instance;
  }));
  var tmp_5 = get_centered(view_0);
  var tmp_6 = view_0.ibb(view_0.ibb(tmp_5, shownWhen(view_0, VOID, ($this$shownWhen) => !$this$shownWhen.baj(status).equals(PayAppStatus_Draft_getInstance()))), get_secondaryButton(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  specCenteredText_0(view_1, renderPayApp2$lambda);
  view_1.eba(get_dp(5));
  onClick(view_1, VOID, VOID, renderPayApp2$slambda_2(payApp, _this__u8e3s4, items));
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_6, view_1);
  var tmp_7 = shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj(status).equals(PayAppStatus_Draft_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.xbm(false);
  var tmp_8 = get_centered(view_2);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$63 = view_2.hbb(ButtonSemantic_getInstance());
  var tmp_9 = view_2.ibb(tmp_8, tmp$ret$63);
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Link())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.eba(get_rem_0(0.25));
  view_3.zb8(get_rem_0(0.25));
  var tmp_10 = KMutableProperty0();
  var tmp_11 = Link$_get_to_$ref_jq7esp(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('to', 0, tmp_10, tmp_11, Link$_set_to_$ref_i9gu5x(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var $this$invoke = $this$reactiveScope;
    var tmp$ret$64 = () => new (PayAppForm())($this$invoke.baj(payApp).i6y_1);
    this_0.set(tmp$ret$64);
    return Unit_instance;
  });
  view_3.jbb(get_centered(view_3), icon(view_3, resize(get_edit(Companion_getInstance()), get_rem_0(1.25)), 'Edit Change Order'));
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_9, view_3);
  var tmp_12 = view_2.ibb(view_2.ibb(get_compact(view_2), get_centered(view_2)), get_deleteButton(view_2));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  view_4.jbb(get_centered(view_4), icon(view_4, resize(get_trash(Companion_getInstance()), get_rem_0(1.25)), 'Delete'));
  onClick(view_4, VOID, VOID, renderPayApp2$slambda_4(payApp));
  view_2.fbb(p_4, view_4);
  view_2.jbb(tmp_12, view_4);
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_7, view_2);
  view.fbb(p_0, view_0);
  view.jbb(tmp_2, view_0);
  var tmp_13 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expanded));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_5 = view.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.ebb(p_5, view_5);
  view_5.xbm(true);
  var $this$table = view_5;
  trackWeights(($this$trackWeights) => {
    var rowPadding = get_rem_0(0.5);
    $this$table.zb8(get_rem(0));
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_0 = $this$table;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Space())(this_0.pc());
    var tmp0_elvis_lhs = this_0.cbb_1;
    var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
    this_0.ebb(p, view);
    this_0.fbb(p, view);
    // Inline function 'com.crowpay.views.components.sectionIndentCol' call
    var tmp0 = $this$table;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var indent = Indent_Section_getInstance();
    var tmp2 = indent.ygq_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace = indent.zgq_1;
    var tmp = get_unpadded(tmp0);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(tmp0.pc());
    var tmp0_elvis_lhs_0 = tmp0.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? tmp0 : tmp0_elvis_lhs_0;
    tmp0.ebb(p_0, view_0);
    var tmp_0;
    var tmp_1 = null;
    if (!((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null)) {
      tmp_0 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_0 = Companion_getInstance_0();
    }
    var tmp_2 = view_0.ibb(tmp_0, indented(view_0, tmp2, afterSpace));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.xbm(true);
    var tmp_3 = shownWhen(view_1, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.let' call
      var it = $this$shownWhen.baj(payApp);
      var tmp;
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = it.n6y_1;
      if (!isBlank(this_0)) {
        tmp = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !it.o6y_1.i1();
      }
      return tmp;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    view_2.xbm(true);
    var tmp_4 = shownWhen(view_2, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = $this$shownWhen.baj(payApp).n6y_1;
      return !isBlank(this_0);
    });
    view_2.jbb(tmp_4, label2(view_2, 'Description', VOID, ($this$label2) => {
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (TextView())($this$label2.pc());
      var tmp0_elvis_lhs = $this$label2.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
      $this$label2.ebb(p, view);
      view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl_5(view);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_5(view));
      reactiveScope(view, ($this$reactiveScope) => {
        var tmp$ret$88 = $this$reactiveScope.baj(payApp).n6y_1;
        this_0.set(tmp$ret$88);
        return Unit_instance;
      });
      $this$label2.fbb(p, view);
      return view;
    }));
    var tmp_5 = shownWhen(view_2, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownWhen.baj(payApp).o6y_1.i1();
    });
    view_2.jbb(tmp_5, label2(view_2, 'Attachments', VOID, ($this$label2) => renderFiles($this$label2, lens(payApp, renderPayApp2$lambda$lambda$lambda), times(get_AppDimensions().qg2_1, 0.75))));
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Space())(view_2.pc(), 1.5);
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_2.fbb(p_3, view_3);
    view_1.fbb(p_2, view_2);
    view_1.jbb(tmp_3, view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_4 = view_1.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
    view_1.ebb(p_4, view_4);
    view_4.xbm(false);
    view_4.jbb(view_4.ibb($this$trackWeights.mg6(view_4, 6.0), get_atBottomCenter(view_4)), bodyBold(view_4, 'Work Item'));
    view_4.jbb(view_4.ibb($this$trackWeights.mg6(view_4, 1.0), get_atBottomCenter(view_4)), renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$centeredHeader_44vw30(view_4, 'Work Value'));
    view_4.jbb(view_4.ibb($this$trackWeights.mg6(view_4, 1.0), get_atBottomCenter(view_4)), renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$centeredHeader_44vw30(view_4, 'Retention'));
    view_4.jbb(view_4.ibb($this$trackWeights.mg6(view_4, 1.0), get_atBottomCenter(view_4)), renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$centeredHeader_44vw30(view_4, 'Due'));
    view_4.jbb(view_4.ibb($this$trackWeights.mg6(view_4, 1.0), get_atBottomCenter(view_4)), renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$centeredHeader_44vw30(view_4, 'Payment'));
    view_1.fbb(p_4, view_4);
    greySeparator(view_1);
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_2, view_1);
    tmp0.fbb(p_0, view_0);
    tmp0.jbb(tmp, view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_1 = $this$table;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(this_1.pc());
    var tmp0_elvis_lhs_5 = this_1.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? this_1 : tmp0_elvis_lhs_5;
    this_1.ebb(p_5, view_5);
    view_5.xbm(true);
    view_5.zb8(get_rem(0));
    if (_this__u8e3s4.rgj().equals(ProjectLens_Customer_getInstance())) {
      var tmp_6 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(2.5));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (RowOrCol())(view_5.pc());
      var tmp0_elvis_lhs_6 = view_5.cbb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
      view_5.ebb(p_6, view_6);
      view_6.xbm(true);
      shownDefaultFalse(view_6, ($this$shownDefaultFalse) => {
        // Inline function 'kotlin.collections.isNotEmpty' call
        return !$this$shownDefaultFalse.baj(pending).i1();
      });
      view_6.zb8(get_rem(0));
      var tmp_7 = sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, rowPadding);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_7 = new (Frame())(view_6.pc());
      var tmp0_elvis_lhs_7 = view_6.cbb_1;
      var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
      view_6.ebb(p_7, view_7);
      view_6.fbb(p_7, view_7);
      view_6.jbb(tmp_7, view_7);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_8 = new (RowOrCol())(view_6.pc());
      var tmp0_elvis_lhs_8 = view_6.cbb_1;
      var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
      view_6.ebb(p_8, view_8);
      view_8.xbm(false);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_9 = new (Frame())(view_8.pc());
      var tmp0_elvis_lhs_9 = view_8.cbb_1;
      var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
      view_8.ebb(p_9, view_9);
      var tmp_8 = align(view_9, Align_Start_getInstance(), Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_10 = new (Checkbox())(view_9.pc());
      var tmp0_elvis_lhs_10 = view_9.cbb_1;
      var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
      view_9.ebb(p_10, view_10);
      view_10.xah(view_10.cbk_1, allSelected);
      view_9.fbb(p_10, view_10);
      view_9.jbb(tmp_8, view_10);
      view_8.fbb(p_9, view_9);
      view_8.jbb(view_8.ibb(get_centered(view_8), get_expanding(view_8)), bodyBold(view_8, 'Select All'));
      view_6.fbb(p_8, view_8);
      var tmp_9 = sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, rowPadding);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_11 = new (Frame())(view_6.pc());
      var tmp0_elvis_lhs_11 = view_6.cbb_1;
      var p_11 = tmp0_elvis_lhs_11 == null ? view_6 : tmp0_elvis_lhs_11;
      view_6.ebb(p_11, view_11);
      view_6.fbb(p_11, view_11);
      view_6.jbb(tmp_9, view_11);
      // Inline function 'com.crowpay.views.components.sectionIndentCol' call
      // Inline function 'com.crowpay.views.components.indentedCol' call
      var indent_0 = Indent_Section_getInstance();
      var tmp2_0 = indent_0.ygq_1;
      // Inline function 'com.crowpay.views.components.indentedCol' call
      var afterSpace_0 = indent_0.zgq_1;
      var tmp_10 = get_unpadded(view_6);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_12 = new (Frame())(view_6.pc());
      var tmp0_elvis_lhs_12 = view_6.cbb_1;
      var p_12 = tmp0_elvis_lhs_12 == null ? view_6 : tmp0_elvis_lhs_12;
      view_6.ebb(p_12, view_12);
      var tmp_11;
      var tmp_12 = null;
      if (!((tmp_12 == null ? null : new (Dimension())(tmp_12)) == null)) {
        tmp_11 = sizeConstraints(view_12, VOID, VOID, VOID, VOID, VOID, null);
      } else {
        tmp_11 = Companion_getInstance_0();
      }
      var tmp_13 = view_12.ibb(tmp_11, indented(view_12, tmp2_0, afterSpace_0));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_13 = new (RowOrCol())(view_12.pc());
      var tmp0_elvis_lhs_13 = view_12.cbb_1;
      var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
      view_12.ebb(p_13, view_13);
      view_13.xbm(true);
      greySeparator(view_13);
      view_12.fbb(p_13, view_13);
      view_12.jbb(tmp_13, view_13);
      view_6.fbb(p_12, view_12);
      view_6.jbb(tmp_10, view_12);
      var tmp_14 = sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, rowPadding);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_14 = new (Frame())(view_6.pc());
      var tmp0_elvis_lhs_14 = view_6.cbb_1;
      var p_14 = tmp0_elvis_lhs_14 == null ? view_6 : tmp0_elvis_lhs_14;
      view_6.ebb(p_14, view_14);
      view_6.fbb(p_14, view_14);
      view_6.jbb(tmp_14, view_14);
      view_5.fbb(p_6, view_6);
      view_5.jbb(tmp_6, view_6);
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_15 = new (RowOrCol())(view_5.pc());
    var tmp0_elvis_lhs_15 = view_5.cbb_1;
    var p_15 = tmp0_elvis_lhs_15 == null ? view_5 : tmp0_elvis_lhs_15;
    view_5.ebb(p_15, view_15);
    view_15.xbm(true);
    forEachUpdating(view_15, groupedItems, VOID, ($this$forEachUpdating, pair) => {
      var scope = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(pair).af_1);
      var lines = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(pair).bf_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEachUpdating.pc());
      var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
      $this$forEachUpdating.ebb(p, view);
      view.xbm(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.xbm(true);
      var tmp = KMutableProperty0();
      var tmp_0 = RowOrCol$_get_shown_$ref_m8lfse(view_0);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, RowOrCol$_set_shown_$ref_7290m6(view_0));
      reactiveScope(view_0, ($this$reactiveScope) => {
        var tmp$ret$151 = !($this$reactiveScope.baj(scope) == null);
        this_0.set(tmp$ret$151);
        return Unit_instance;
      });
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Space())(view_0.pc(), 0.25);
      var tmp0_elvis_lhs_1 = view_0.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.ebb(p_1, view_1);
      view_0.fbb(p_1, view_1);
      var tmp_1 = view_0.ibb(get_compact(view_0), get_lightSection(view_0));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (RowOrCol())(view_0.pc());
      var tmp0_elvis_lhs_2 = view_0.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
      view_0.ebb(p_2, view_2);
      view_2.xbm(false);
      var tmp_2 = get_centered(view_2);
      var tmp_3 = get_rem(1);
      view_2.jbb(tmp_2, scopeSetIcon(view_2, tmp_3, ($this$scopeSetIcon) => {
        var tmp = KMutableProperty0();
        var tmp_0 = IconView$_get_shown_$ref_js8irt($this$scopeSetIcon);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, IconView$_set_shown_$ref_9ilxmr($this$scopeSetIcon));
        reactiveScope($this$scopeSetIcon, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(scope);
          var tmp$ret$156 = !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p7z_1) == null);
          this_0.set(tmp$ret$156);
          return Unit_instance;
        });
        return Unit_instance;
      }));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (TextView())(view_2.pc());
      var tmp0_elvis_lhs_3 = view_2.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
      view_2.ebb(p_3, view_3);
      view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp_4 = KMutableProperty0();
      var tmp_5 = TextView$_get_content_$ref_4pzcwl_6(view_3);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_6(view_3));
      reactiveScope(view_3, ($this$reactiveScope) => {
        var tmp0_safe_receiver = $this$reactiveScope.baj(scope);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m7z_1;
        var tmp$ret$158 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        this_1.set(tmp$ret$158);
        return Unit_instance;
      });
      view_2.fbb(p_3, view_3);
      view_0.fbb(p_2, view_2);
      view_0.jbb(tmp_1, view_2);
      view.fbb(p_0, view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_4 = view.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
      view.ebb(p_4, view_4);
      view_4.xbm(true);
      view_4.zb8(get_rem(0));
      var anyReviewed = remember(VOID, VOID, VOID, ($this$remember) => {
        var tmp = asSequence($this$remember.baj(lines));
        var tmp0 = mapNotNull(tmp, renderPayApp2$lambda$lambda$lambda$lambda);
        var tmp$ret$174;
        $l$block_1: {
          // Inline function 'kotlin.sequences.any' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!get_status(element).equals(PayAppStatus_Pending_getInstance())) {
              tmp$ret$174 = true;
              break $l$block_1;
            }
          }
          tmp$ret$174 = false;
        }
        return tmp$ret$174;
      });
      forEachUpdating(view_4, lines, VOID, ($this$forEachUpdating, lineItemWithPayment) => {
        var tmp = sizeConstraints($this$forEachUpdating, VOID, VOID, VOID, VOID, VOID, VOID, rowPadding);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())($this$forEachUpdating.pc());
        var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
        var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
        $this$forEachUpdating.ebb(p, view);
        view.xbm(false);
        $this$forEachUpdating.fbb(p, view);
        $this$forEachUpdating.jbb(tmp, view);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())($this$forEachUpdating.pc());
        var tmp0_elvis_lhs_0 = $this$forEachUpdating.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? $this$forEachUpdating : tmp0_elvis_lhs_0;
        $this$forEachUpdating.ebb(p_0, view_0);
        view_0.xbm(false);
        dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.baj(lineItemWithPayment).rhc_1.of9_1 ? GreyedOutSemantic_getInstance() : null);
        var tmp_0 = get_centered(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(false);
        var tmp_1 = KMutableProperty0();
        var tmp_2 = RowOrCol$_get_visible_$ref_m9hbzh(view_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('visible', 0, tmp_1, tmp_2, RowOrCol$_set_visible_$ref_80wucf(view_1));
        reactiveScope(view_1, ($this$reactiveScope) => {
          var tmp;
          var tmp_0;
          if (_this__u8e3s4.rgj().equals(ProjectLens_Customer_getInstance())) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp_0 = !$this$reactiveScope.baj(pending).i1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            var tmp0_safe_receiver = $this$reactiveScope.baj(lineItemWithPayment).shc_1;
            tmp = equals(tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver), PayAppStatus_Pending_getInstance());
          } else {
            tmp = false;
          }
          var tmp$ret$180 = tmp;
          this_0.set(tmp$ret$180);
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Frame())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        var tmp_3 = align(view_2, Align_Start_getInstance(), Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Checkbox())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xah(view_3.cbk_1, containsDynamic(selectedItems, ($this$containsDynamic) => $this$containsDynamic.baj(lineItemWithPayment).rhc_1.kf9_1));
        view_2.fbb(p_3, view_3);
        view_2.jbb(tmp_3, view_3);
        view_1.fbb(p_2, view_2);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        var tmp_4 = view_0.ibb(get_centered(view_0), $this$trackWeights.ng6(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.ebb(p_4, view_4);
        view_4.xbm(false);
        view_4.zb8(get_dp(5));
        var tmp_5 = get_centered(view_4);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.ebb(p_5, view_5);
        view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
        var tmp_6 = KMutableProperty0();
        var tmp_7 = TextView$_get_content_$ref_4pzcwl_7(view_5);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_7(view_5));
        reactiveScope(view_5, ($this$reactiveScope) => {
          var tmp$ret$192 = $this$reactiveScope.baj(lineItemWithPayment).k20();
          this_1.set(tmp$ret$192);
          return Unit_instance;
        });
        view_4.fbb(p_5, view_5);
        view_4.jbb(tmp_5, view_5);
        var tmp_8 = get_centered(view_4);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextView())(view_4.pc());
        var tmp0_elvis_lhs_6 = view_4.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
        view_4.ebb(p_6, view_6);
        view_6.jba(view_6.ob6_1.ybe(SmallBodySemantic_getInstance()));
        var tmp_9 = KMutableProperty0();
        var tmp_10 = TextView$_get_content_$ref_4pzcwl_8(view_6);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_8(view_6));
        reactiveScope(view_6, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(lineItemWithPayment).rhc_1.z94();
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f95_1;
          var tmp$ret$199 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
          this_2.set(tmp$ret$199);
          return Unit_instance;
        });
        view_4.fbb(p_6, view_6);
        view_4.jbb(tmp_8, view_6);
        var tmp_11 = view_4.ibb(shownWhen(view_4, VOID, ($this$shownWhen) => !($this$shownWhen.baj(lineItemWithPayment).shc_1 == null) && $this$shownWhen.baj(anyReviewed)), get_centered(view_4));
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (IconView())(view_4.pc());
        var tmp0_elvis_lhs_7 = view_4.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
        view_4.ebb(p_7, view_7);
        var tmp_12 = KMutableProperty0();
        var tmp_13 = IconView$_get_source_$ref_hlcyij(view_7);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_3 = getPropertyCallableRef('source', 0, tmp_12, tmp_13, IconView$_set_source_$ref_2j4ddb(view_7));
        reactiveScope(view_7, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(lineItemWithPayment).shc_1;
          var tmp1_subject = tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver);
          var tmp0 = tmp1_subject == null ? -1 : tmp1_subject.b4_1;
          var tmp$ret$206 = tmp0 === 4 ? Companion_getInstance().tcf_1 : tmp0 === 6 ? Companion_getInstance().tcf_1 : tmp0 === 5 ? Companion_getInstance().vcf_1 : tmp0 === 1 ? resize(Companion_getInstance().ncf_1, get_rem_0(1.7)) : null;
          this_3.set(tmp$ret$206);
          return Unit_instance;
        });
        view_7.ebu('Draw Item status');
        dynamicTheme(view_7, ($this$dynamicTheme) => {
          var tmp0_safe_receiver = $this$dynamicTheme.baj(lineItemWithPayment).shc_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver);
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.xhf_1;
          return ForegroundSemantic().agi(tmp2_elvis_lhs == null ? Companion_getInstance_3().saz_1 : tmp2_elvis_lhs);
        });
        view_4.fbb(p_7, view_7);
        view_4.jbb(tmp_11, view_7);
        view_0.fbb(p_4, view_4);
        view_0.jbb(tmp_4, view_4);
        var tmp_14 = $this$trackWeights.ng6(view_0);
        view_0.jbb(tmp_14, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_j88tak(view_0, ($this$money) => {
          var tmp = $this$money.baj(lineItemWithPayment).yhc_1;
          return tmp == null ? null : new (MonetaryValue())(tmp);
        }));
        var tmp_15 = $this$trackWeights.ng6(view_0);
        view_0.jbb(tmp_15, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_j88tak(view_0, ($this$money) => {
          var tmp0_elvis_lhs = $this$money.baj(lineItemWithPayment).yhc_1;
          var tmp;
          var tmp_0 = tmp0_elvis_lhs;
          if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
            return null;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var payment = tmp;
          return new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7(payment, $this$money.baj(_this__u8e3s4.jfy()).u97()));
        }));
        var tmp_16 = $this$trackWeights.ng6(view_0);
        view_0.jbb(tmp_16, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_j88tak(view_0, ($this$money) => {
          var tmp0_elvis_lhs = $this$money.baj(lineItemWithPayment).yhc_1;
          var tmp;
          var tmp_0 = tmp0_elvis_lhs;
          if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
            return null;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var payment = tmp;
          return new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(payment, MonetaryValue__times_impl_hlr6p7(payment, $this$money.baj(_this__u8e3s4.jfy()).u97())));
        }));
        var tmp_17 = $this$trackWeights.ng6(view_0);
        view_0.jbb(tmp_17, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_j88tak(view_0, ($this$money) => {
          // Inline function 'kotlin.let' call
          var it = $this$money.baj(lineItemWithPayment);
          var tmp0_elvis_lhs = it.shc_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var draw = tmp;
          var tmp_0 = get_status(draw).equals(PayAppStatus_Approved_getInstance()) || $this$money.baj(selectedItems).t1(it.rhc_1.kf9_1) ? MonetaryValue__minus_impl_jw9qyp(draw.t6v_1, MonetaryValue__times_impl_hlr6p7(draw.t6v_1, $this$money.baj(_this__u8e3s4.jfy()).u97())) : get_status(draw).equals(PayAppStatus_Denied_getInstance()) ? Companion_instance.p91(0n) : null;
          var tmp_1 = tmp_0 == null ? null : new (MonetaryValue())(tmp_0);
          var tmp_2 = tmp_1 == null ? null : tmp_1.a5s_1;
          return tmp_2 == null ? null : new (MonetaryValue())(tmp_2);
        }));
        $this$forEachUpdating.fbb(p_0, view_0);
        var tmp_18 = sizeConstraints($this$forEachUpdating, VOID, VOID, VOID, VOID, VOID, VOID, rowPadding);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())($this$forEachUpdating.pc());
        var tmp0_elvis_lhs_8 = $this$forEachUpdating.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? $this$forEachUpdating : tmp0_elvis_lhs_8;
        $this$forEachUpdating.ebb(p_8, view_8);
        view_8.xbm(false);
        $this$forEachUpdating.fbb(p_8, view_8);
        $this$forEachUpdating.jbb(tmp_18, view_8);
        // Inline function 'com.crowpay.views.components.sectionIndentCol' call
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var indent = Indent_Section_getInstance();
        var tmp2 = indent.ygq_1;
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var afterSpace = indent.zgq_1;
        var tmp_19 = get_unpadded($this$forEachUpdating);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Frame())($this$forEachUpdating.pc());
        var tmp0_elvis_lhs_9 = $this$forEachUpdating.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? $this$forEachUpdating : tmp0_elvis_lhs_9;
        $this$forEachUpdating.ebb(p_9, view_9);
        var tmp_20;
        var tmp_21 = null;
        if (!((tmp_21 == null ? null : new (Dimension())(tmp_21)) == null)) {
          tmp_20 = sizeConstraints(view_9, VOID, VOID, VOID, VOID, VOID, null);
        } else {
          tmp_20 = Companion_getInstance_0();
        }
        var tmp_22 = view_9.ibb(tmp_20, indented(view_9, tmp2, afterSpace));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (RowOrCol())(view_9.pc());
        var tmp0_elvis_lhs_10 = view_9.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
        view_9.ebb(p_10, view_10);
        view_10.xbm(true);
        greySeparator(view_10);
        view_9.fbb(p_10, view_10);
        view_9.jbb(tmp_22, view_10);
        $this$forEachUpdating.fbb(p_9, view_9);
        $this$forEachUpdating.jbb(tmp_19, view_9);
        return Unit_instance;
      });
      view.fbb(p_4, view_4);
      $this$forEachUpdating.fbb(p, view);
      return Unit_instance;
    });
    view_5.fbb(p_15, view_15);
    this_1.fbb(p_5, view_5);
    // Inline function 'com.crowpay.views.components.sectionIndentCol' call
    var tmp0_0 = $this$table;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var indent_1 = Indent_Section_getInstance();
    var tmp2_1 = indent_1.ygq_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace_1 = indent_1.zgq_1;
    var tmp_15 = get_unpadded(tmp0_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_16 = new (Frame())(tmp0_0.pc());
    var tmp0_elvis_lhs_16 = tmp0_0.cbb_1;
    var p_16 = tmp0_elvis_lhs_16 == null ? tmp0_0 : tmp0_elvis_lhs_16;
    tmp0_0.ebb(p_16, view_16);
    var tmp_16;
    var tmp_17 = null;
    if (!((tmp_17 == null ? null : new (Dimension())(tmp_17)) == null)) {
      tmp_16 = sizeConstraints(view_16, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_16 = Companion_getInstance_0();
    }
    var tmp_18 = view_16.ibb(tmp_16, indented(view_16, tmp2_1, afterSpace_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_17 = new (RowOrCol())(view_16.pc());
    var tmp0_elvis_lhs_17 = view_16.cbb_1;
    var p_17 = tmp0_elvis_lhs_17 == null ? view_16 : tmp0_elvis_lhs_17;
    view_16.ebb(p_17, view_17);
    view_17.xbm(true);
    var tmp_19 = sizeConstraints(view_17, VOID, VOID, VOID, VOID, VOID, VOID, rowPadding);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_18 = new (RowOrCol())(view_17.pc());
    var tmp0_elvis_lhs_18 = view_17.cbb_1;
    var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
    view_17.ebb(p_18, view_18);
    view_18.xbm(false);
    view_17.fbb(p_18, view_18);
    view_17.jbb(tmp_19, view_18);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_19 = new (RowOrCol())(view_17.pc());
    var tmp0_elvis_lhs_19 = view_17.cbb_1;
    var p_19 = tmp0_elvis_lhs_19 == null ? view_17 : tmp0_elvis_lhs_19;
    view_17.ebb(p_19, view_19);
    view_19.xbm(false);
    view_19.jbb($this$trackWeights.ng6(view_19), bodyBold(view_19, 'Total Requested'));
    var tmp_20 = $this$trackWeights.ng6(view_19);
    view_19.jbb(tmp_20, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_pymgmy(view_19, ($this$moneyBold) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$moneyBold.baj(items);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.yhc_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$255 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$255);
      }
      var tmp$ret$256 = sum;
      return new (MonetaryValue())(tmp$ret$256);
    }));
    var tmp_21 = $this$trackWeights.ng6(view_19);
    view_19.jbb(tmp_21, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_pymgmy(view_19, ($this$moneyBold) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$moneyBold.baj(items);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.yhc_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$257 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$257);
      }
      var tmp$ret$258 = sum;
      return new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7(tmp$ret$258, $this$moneyBold.baj(_this__u8e3s4.jfy()).u97()));
    }));
    var tmp_22 = $this$trackWeights.ng6(view_19);
    view_19.jbb(tmp_22, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_pymgmy(view_19, ($this$moneyBold) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$moneyBold.baj(items);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.yhc_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$259 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$259);
      }
      var tmp_2 = sum;
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_1 = $this$moneyBold.baj(items);
      var sum_0 = Companion_instance.p91(0n);
      var _iterator__ex2g4s_0 = this_1.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        var tmp_3 = sum_0;
        var tmp0_elvis_lhs_0 = element_0.yhc_1;
        var tmp_4;
        var tmp_5 = tmp0_elvis_lhs_0;
        if ((tmp_5 == null ? null : new (MonetaryValue())(tmp_5)) == null) {
          tmp_4 = Companion_instance.p91(0n);
        } else {
          tmp_4 = tmp0_elvis_lhs_0;
        }
        var tmp$ret$261 = tmp_4;
        sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_3, tmp$ret$261);
      }
      var tmp$ret$262 = sum_0;
      return new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(tmp_2, MonetaryValue__times_impl_hlr6p7(tmp$ret$262, $this$moneyBold.baj(_this__u8e3s4.jfy()).u97())));
    }));
    var tmp_23 = $this$trackWeights.ng6(view_19);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_20 = new (TextView())(view_19.pc());
    var tmp0_elvis_lhs_20 = view_19.cbb_1;
    var p_20 = tmp0_elvis_lhs_20 == null ? view_19 : tmp0_elvis_lhs_20;
    view_19.ebb(p_20, view_20);
    view_20.jba(view_20.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_24 = view_20.tb5_1;
    var tmp_25;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('-') === 0) {
      tmp_25 = '\xA0';
    } else {
      tmp_25 = '-';
    }
    tmp_24.fbu(tmp_25);
    view_20.bbs(Align_Center_getInstance());
    view_19.fbb(p_20, view_20);
    view_19.jbb(tmp_23, view_20);
    view_17.fbb(p_19, view_19);
    view_16.fbb(p_17, view_17);
    view_16.jbb(tmp_18, view_17);
    tmp0_0.fbb(p_16, view_16);
    tmp0_0.jbb(tmp_15, view_16);
    // Inline function 'com.crowpay.views.components.sectionIndentCol' call
    var tmp0_1 = $this$table;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var indent_2 = Indent_Section_getInstance();
    var tmp2_2 = indent_2.ygq_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace_2 = indent_2.zgq_1;
    var tmp_26 = get_unpadded(tmp0_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_21 = new (Frame())(tmp0_1.pc());
    var tmp0_elvis_lhs_21 = tmp0_1.cbb_1;
    var p_21 = tmp0_elvis_lhs_21 == null ? tmp0_1 : tmp0_elvis_lhs_21;
    tmp0_1.ebb(p_21, view_21);
    var tmp_27;
    var tmp_28 = null;
    if (!((tmp_28 == null ? null : new (Dimension())(tmp_28)) == null)) {
      tmp_27 = sizeConstraints(view_21, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_27 = Companion_getInstance_0();
    }
    var tmp_29 = view_21.ibb(tmp_27, indented(view_21, tmp2_2, afterSpace_2));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_22 = new (RowOrCol())(view_21.pc());
    var tmp0_elvis_lhs_22 = view_21.cbb_1;
    var p_22 = tmp0_elvis_lhs_22 == null ? view_21 : tmp0_elvis_lhs_22;
    view_21.ebb(p_22, view_22);
    view_22.xbm(true);
    space(view_22, rowPadding);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_23 = new (RowOrCol())(view_22.pc());
    var tmp0_elvis_lhs_23 = view_22.cbb_1;
    var p_23 = tmp0_elvis_lhs_23 == null ? view_22 : tmp0_elvis_lhs_23;
    view_22.ebb(p_23, view_23);
    view_23.xbm(false);
    var actual = remember(VOID, VOID, VOID, ($this$remember) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.baj(items);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp;
        var tmp0_safe_receiver = element.shc_1;
        if (equals(tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver), PayAppStatus_Approved_getInstance())) {
          tmp = true;
        } else {
          tmp = $this$remember.baj(selectedItems).t1(element.rhc_1.kf9_1);
        }
        if (tmp) {
          destination.v(element);
        }
      }
      return destination;
    });
    view_23.jbb($this$trackWeights.ng6(view_23), bodyBold(view_23, 'Actuals'));
    var tmp_30 = $this$trackWeights.ng6(view_23);
    view_23.jbb(tmp_30, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold$0_hf2w1y(view_23, ($this$moneyBold) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$moneyBold.baj(actual);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.yhc_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$287 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$287);
      }
      var tmp$ret$288 = sum;
      return new (MonetaryValue())(tmp$ret$288);
    }));
    var tmp_31 = $this$trackWeights.ng6(view_23);
    view_23.jbb(tmp_31, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold$0_hf2w1y(view_23, ($this$moneyBold) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$moneyBold.baj(actual);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.yhc_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$289 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$289);
      }
      var tmp$ret$290 = sum;
      return new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7(tmp$ret$290, $this$moneyBold.baj(_this__u8e3s4.jfy()).u97()));
    }));
    var tmp_32 = $this$trackWeights.ng6(view_23);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_24 = new (TextView())(view_23.pc());
    var tmp0_elvis_lhs_24 = view_23.cbb_1;
    var p_24 = tmp0_elvis_lhs_24 == null ? view_23 : tmp0_elvis_lhs_24;
    view_23.ebb(p_24, view_24);
    view_24.jba(view_24.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    view_24.bbs(Align_Center_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_33 = view_24.tb5_1;
    var tmp_34;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('-') === 0) {
      tmp_34 = '\xA0';
    } else {
      tmp_34 = '-';
    }
    tmp_33.fbu(tmp_34);
    view_23.fbb(p_24, view_24);
    view_23.jbb(tmp_32, view_24);
    var tmp_35 = $this$trackWeights.ng6(view_23);
    view_23.jbb(tmp_35, renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold$0_hf2w1y(view_23, ($this$moneyBold) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$moneyBold.baj(actual);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.yhc_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$298 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$298);
      }
      var tmp_2 = sum;
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_1 = $this$moneyBold.baj(actual);
      var sum_0 = Companion_instance.p91(0n);
      var _iterator__ex2g4s_0 = this_1.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        var tmp_3 = sum_0;
        var tmp0_elvis_lhs_0 = element_0.yhc_1;
        var tmp_4;
        var tmp_5 = tmp0_elvis_lhs_0;
        if ((tmp_5 == null ? null : new (MonetaryValue())(tmp_5)) == null) {
          tmp_4 = Companion_instance.p91(0n);
        } else {
          tmp_4 = tmp0_elvis_lhs_0;
        }
        var tmp$ret$300 = tmp_4;
        sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_3, tmp$ret$300);
      }
      var tmp$ret$301 = sum_0;
      return new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(tmp_2, MonetaryValue__times_impl_hlr6p7(tmp$ret$301, $this$moneyBold.baj(_this__u8e3s4.jfy()).u97())));
    }));
    view_22.fbb(p_23, view_23);
    view_21.fbb(p_22, view_22);
    view_21.jbb(tmp_29, view_22);
    tmp0_1.fbb(p_21, view_21);
    tmp0_1.jbb(tmp_26, view_21);
    return Unit_instance;
  });
  launch($this$table, VOID, VOID, renderPayApp2$slambda_6(_this__u8e3s4, selectedItems, pending, payApp, $this$table, expanded));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Space())($this$table.pc());
  var tmp0_elvis_lhs_6 = $this$table.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? $this$table : tmp0_elvis_lhs_6;
  $this$table.ebb(p_6, view_6);
  $this$table.fbb(p_6, view_6);
  var tmp_14 = get_atEnd($this$table);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())($this$table.pc());
  var tmp0_elvis_lhs_7 = $this$table.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? $this$table : tmp0_elvis_lhs_7;
  $this$table.ebb(p_7, view_7);
  view_7.xbm(false);
  var tmp_15 = get_secondaryButton(view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (Button())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.ebb(p_8, view_8);
  shownDefaultFalse(view_8, ($this$shownDefaultFalse) => {
    var tmp0 = $this$shownDefaultFalse.baj(items);
    var tmp$ret$319;
    $l$block_3: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$319 = false;
        break $l$block_3;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp0_safe_receiver = element.shc_1;
        if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v6v_1) == null)) {
          tmp$ret$319 = true;
          break $l$block_3;
        }
      }
      tmp$ret$319 = false;
    }
    return tmp$ret$319;
  });
  specCenteredTextWithUnread(view_8, 'View Reason', ($this$specCenteredTextWithUnread) => $this$specCenteredTextWithUnread.baj($this$specCenteredTextWithUnread.baj(feedbackUnread)));
  onClick(view_8, VOID, VOID, renderPayApp2$slambda_8(items, payApp, _this__u8e3s4));
  view_7.fbb(p_8, view_8);
  view_7.jbb(tmp_15, view_8);
  if (_this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance())) {
    var tmp_16 = view_7.ibb(shownWhen(view_7, VOID, ($this$shownWhen) => {
      var tmp0_elvis_lhs = $this$shownWhen.baj(_this__u8e3s4.pgj_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var myRole = tmp;
      var tmp_0;
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this$shownWhen.baj(pending).i1()) {
        var tmp0 = $this$shownWhen.baj(pending);
        var tmp$ret$325;
        $l$block_5: {
          // Inline function 'kotlin.collections.all' call
          var tmp_2;
          if (isInterface(tmp0, Collection())) {
            tmp_2 = tmp0.i1();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$325 = true;
            break $l$block_5;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.shc_1;
            if (!equals(tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver), PayAppStatus_Pending_getInstance())) {
              tmp$ret$325 = false;
              break $l$block_5;
            }
          }
          tmp$ret$325 = true;
        }
        tmp_1 = tmp$ret$325;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = myRole.d4(MemberRole_Manager_getInstance()) >= 0;
      } else {
        tmp_0 = false;
      }
      return tmp_0;
    }), view_7.hbb(DangerButtonSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Button())(view_7.pc());
    var tmp0_elvis_lhs_9 = view_7.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
    view_7.ebb(p_9, view_9);
    specCenteredText(view_9, 'Void');
    onClick(view_9, 'Void Draw', VOID, renderPayApp2$slambda_10(items));
    view_7.fbb(p_9, view_9);
    view_7.jbb(tmp_16, view_9);
  }
  if (_this__u8e3s4.rgj().equals(ProjectLens_Customer_getInstance())) {
    var tmp_17 = get_primaryButton(view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (Button())(view_7.pc());
    var tmp0_elvis_lhs_10 = view_7.cbb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view_7 : tmp0_elvis_lhs_10;
    view_7.ebb(p_10, view_10);
    var tmp_18 = KMutableProperty0();
    var tmp_19 = Button$_get_shown_$ref_hkylj1(view_10);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('shown', 0, tmp_18, tmp_19, Button$_set_shown_$ref_bpvuvj(view_10));
    reactiveScope(view_10, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$331 = !$this$reactiveScope.baj(pending).i1();
      this_1.set(tmp$ret$331);
      return Unit_instance;
    });
    var tmp_20 = KMutableProperty0();
    var tmp_21 = Button$_get_enabled_$ref_61t7nx_2(view_10);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('enabled', 0, tmp_20, tmp_21, Button$_set_enabled_$ref_o8kynz_2(view_10));
    reactiveScope(view_10, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$334 = !$this$reactiveScope.baj(selectedItems).i1();
      this_2.set(tmp$ret$334);
      return Unit_instance;
    });
    specCenteredText_0(view_10, ($this$specCenteredText) => 'Pay ' + $this$specCenteredText.baj(labelValue));
    onClick(view_10, 'Pay Selected Draws', VOID, renderPayApp2$slambda_12(pending, selectedItems, _this__u8e3s4, allSelected));
    view_7.fbb(p_10, view_10);
    view_7.jbb(tmp_17, view_10);
    var tmp_22 = get_dangerButton(view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (Button())(view_7.pc());
    var tmp0_elvis_lhs_11 = view_7.cbb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view_7 : tmp0_elvis_lhs_11;
    view_7.ebb(p_11, view_11);
    var tmp_23 = KMutableProperty0();
    var tmp_24 = Button$_get_shown_$ref_hkylj1_0(view_11);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('shown', 0, tmp_23, tmp_24, Button$_set_shown_$ref_bpvuvj_0(view_11));
    reactiveScope(view_11, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$340 = !$this$reactiveScope.baj(pending).i1();
      this_3.set(tmp$ret$340);
      return Unit_instance;
    });
    var tmp_25 = KMutableProperty0();
    var tmp_26 = Button$_get_enabled_$ref_61t7nx_3(view_11);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_4 = getPropertyCallableRef('enabled', 0, tmp_25, tmp_26, Button$_set_enabled_$ref_o8kynz_3(view_11));
    reactiveScope(view_11, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$343 = !$this$reactiveScope.baj(selectedItems).i1();
      this_4.set(tmp$ret$343);
      return Unit_instance;
    });
    specCenteredText_0(view_11, ($this$specCenteredText) => 'Wait ' + $this$specCenteredText.baj(labelValue));
    onClick(view_11, 'Wait Selected Draws', VOID, renderPayApp2$slambda_14(pending, selectedItems));
    view_7.fbb(p_11, view_11);
    view_7.jbb(tmp_22, view_11);
  }
  $this$table.fbb(p_7, view_7);
  $this$table.jbb(tmp_14, view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (Space())($this$table.pc(), 2.0);
  var tmp0_elvis_lhs_12 = $this$table.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? $this$table : tmp0_elvis_lhs_12;
  $this$table.ebb(p_12, view_12);
  $this$table.fbb(p_12, view_12);
  view.fbb(p_5, view_5);
  view.jbb(tmp_13, view_5);
  greySeparator(view);
  writer.fbb(p, view);
  return view;
}
function *_generator_renderCredit$_anonymous_$destination__r0jisa($credit, $this_renderCredit, workItem, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var tmp = await_0($credit, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var credit = tmp;
  var tmp_0;
  if (!(credit.c5r_1 == null)) {
    var tmp_1 = Companion_instance_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this_renderCredit.tgm();
    var tmp_2 = await_0(this_0, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    // Inline function 'kotlin.collections.find' call
    var tmp0 = tmp_2;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.kf9_1.equals(credit.c5r_1)) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      throw NotFound().nfx(getKClass(LineItem()), null);
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var tmp_4 = tmp_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this_renderCredit.jfy();
    var tmp_5 = await_0(this_1, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var tmp$ret$5 = tmp_5;
    var tmp_6 = tmp_1.cgu(tmp_4, tmp$ret$5, $this_renderCredit.rgj(), VOID, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    tmp_0 = tmp_6;
  } else if (!(credit.d5r_1 == null)) {
    var tmp_7 = Companion_instance_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this_renderCredit.jfy();
    var tmp_8 = await_0(this_2, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    var tmp_9 = tmp_8;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this_renderCredit.ggt();
    var tmp_10 = await_0(this_3, $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
    // Inline function 'kotlin.collections.find' call
    var tmp0_0 = tmp_10;
    var tmp$ret$9;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0_0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (element_0.d63_1.equals(credit.d5r_1)) {
          tmp$ret$9 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$9 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$9;
    var tmp_11;
    if (tmp1_elvis_lhs == null) {
      throw NotFound().nfx(getKClass(Incident()), null);
    } else {
      tmp_11 = tmp1_elvis_lhs;
    }
    var tmp_12 = tmp_11;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = $this_renderCredit.cgt();
    var tmp_13 = await_0(this_4, $completion);
    if (tmp_13 === get_COROUTINE_SUSPENDED())
      tmp_13 = yield tmp_13;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = tmp_13;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s_1 = tmp0_1.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_1 = _iterator__ex2g4s_1.o1();
      if (element_1.x67_1.equals(credit.d5r_1)) {
        destination.v(element_1);
      }
    }
    var tmp_14 = tmp_7.vgq(tmp_9, tmp_12, destination, $this_renderCredit.rgj(), $completion);
    if (tmp_14 === get_COROUTINE_SUSPENDED())
      tmp_14 = yield tmp_14;
    tmp_0 = tmp_14;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = $this_renderCredit.wgk();
    var tmp_15 = await_0(this_5, $completion);
    if (tmp_15 === get_COROUTINE_SUSPENDED())
      tmp_15 = yield tmp_15;
    var client = tmp_15;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = $this_renderCredit.fgl();
    var tmp_16 = await_0(this_6, $completion);
    if (tmp_16 === get_COROUTINE_SUSPENDED())
      tmp_16 = yield tmp_16;
    var contractor = tmp_16;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_7 = get_session();
    var tmp_17 = await_0(this_7, $completion);
    if (tmp_17 === get_COROUTINE_SUSPENDED())
      tmp_17 = yield tmp_17;
    var userId = tmp_17.efv_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_8 = $this_renderCredit.jfy();
    var tmp_18 = await_0(this_8, $completion);
    if (tmp_18 === get_COROUTINE_SUSPENDED())
      tmp_18 = yield tmp_18;
    var tmp_19 = tmp_18;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var tmp_20 = await_0(workItem, $completion);
    if (tmp_20 === get_COROUTINE_SUSPENDED())
      tmp_20 = yield tmp_20;
    var tmp$ret$19 = tmp_20;
    tmp_0 = new (CreditDetails())(credit, client, contractor, userId, tmp_19, tmp$ret$19);
  }
  return tmp_0;
}
function renderCredit$_anonymous_$destination_vf59zy($credit, $this_renderCredit, workItem, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_renderCredit$_anonymous_$destination__r0jisa.bind(VOID, $credit, $this_renderCredit, workItem), $completion);
}
function renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$centeredHeader_44vw30(_this__u8e3s4, text) {
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.fbu(tmp_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_j88tak(_this__u8e3s4, calculation) {
  var tmp = get_centered(_this__u8e3s4);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
  view.bbs(Align_Center_getInstance());
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_9(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_9(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = calculation($this$reactiveScope);
    var tmp0_safe_receiver = tmp == null ? null : tmp.a5s_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = MonetaryValue__toString_impl_xslc77(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp$ret$1 = tmp1_elvis_lhs == null ? '-' : tmp1_elvis_lhs;
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_pymgmy(_this__u8e3s4, calculation) {
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view.bbs(Align_Center_getInstance());
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_10(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_10(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = calculation($this$reactiveScope).a5s_1;
    var tmp$ret$1 = MonetaryValue__toString_impl_xslc77(tmp$ret$0);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderPayApp2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold$0_hf2w1y(_this__u8e3s4, calculation) {
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view.bbs(Align_Center_getInstance());
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_11(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_11(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = calculation($this$reactiveScope).a5s_1;
    var tmp$ret$1 = MonetaryValue__toString_impl_xslc77(tmp$ret$0);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function draws$lambda($this$shownWhen) {
  _init_properties_payAppsTab_kt__q3ukvv();
  // Inline function 'kotlin.let' call
  var it = $this$shownWhen.baj($this$shownWhen.baj(get_session()).pfw_1).m88_1;
  return !(it == null) && it.j8c_1.d4(MemberRole_Manager_getInstance()) >= 0;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = get_dialogStack();
  var tmp_0;
  switch ($this.thj_1.f2().b4_1) {
    case 0:
      // Inline function 'com.lightningkite.reactive.context.invoke' call

      var this_0 = $this.uhj_1.jfy();
      var tmp_1 = await_0(this_0, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var tmp_2 = tmp_1;
      // Inline function 'com.lightningkite.reactive.context.invoke' call

      var this_1 = $this.uhj_1.tgm();
      var tmp_3 = await_0(this_1, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      // Inline function 'kotlin.collections.map' call

      var this_2 = tmp_3;
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList().u(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s = this_2.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp$ret$2 = item.hf9_1;
        destination.v(tmp$ret$2);
      }

      tmp_0 = AddProjectCreditDialog(tmp_2, destination);
      break;
    case 1:
      // Inline function 'com.lightningkite.reactive.context.invoke' call

      var this_3 = $this.vhj_1;
      var tmp_4 = await_1(this_3, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var tmp1_elvis_lhs = tmp_4;
      var tmp_5;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_5 = tmp1_elvis_lhs;
      }

      tmp_0 = AddWorkItemCreditDialog(tmp_5);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  tmp.dbw(tmp_0);
  return Unit_instance;
}
function draws$slambda$lambda$lambda(it) {
  var tmp1_elvis_lhs = it == null ? null : it.u91();
  return tmp1_elvis_lhs == null ? 'None Selected' : tmp1_elvis_lhs;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var draws$slambda$lambda$slambdaClass;
function draws$slambda$lambda$slambda() {
  if (draws$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($selectedKind, $this_draws, $selectedWorkItem) {
        this.thj_1 = $selectedKind;
        this.uhj_1 = $this_draws;
        this.vhj_1 = $selectedWorkItem;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    draws$slambda$lambda$slambdaClass = $;
  }
  return draws$slambda$lambda$slambdaClass;
}
function draws$slambda$lambda$slambda_0($selectedKind, $this_draws, $selectedWorkItem) {
  var i = new (draws$slambda$lambda$slambda())($selectedKind, $this_draws, $selectedWorkItem);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var draws$slambda$lambda$slambdaClass_0;
function draws$slambda$lambda$slambda_1() {
  if (draws$slambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($close) {
        this.whj_1 = $close;
      }
      sao($completion) {
        this.whj_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    draws$slambda$lambda$slambdaClass_0 = $;
  }
  return draws$slambda$lambda$slambdaClass_0;
}
function draws$slambda$lambda$slambda_2($close) {
  var i = new (draws$slambda$lambda$slambda_1())($close);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var draws$slambdaClass;
function draws$slambda() {
  if (draws$slambdaClass === VOID) {
    class $ {
      constructor($this_draws) {
        this.xhj_1 = $this_draws;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        tmp.th2(VOID, VOID, ($this$dialog, close) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$dialog.pc());
          var tmp0_elvis_lhs = $this$dialog.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
          $this$dialog.ebb(p, view);
          view.xbm(true);
          title(view, 'Add Credit');
          body(view, 'Choose what kind of credit you would like to issue.');
          var selectedKind = Signal().fak(CreditKind_Project_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(true);
          var _iterator__ex2g4s = get_entries().m1();
          while (_iterator__ex2g4s.n1()) {
            var kind = _iterator__ex2g4s.o1();
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_1 = new (RowOrCol())(view_0.pc());
            var tmp0_elvis_lhs_1 = view_0.cbb_1;
            var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
            view_0.ebb(p_1, view_1);
            view_1.xbm(false);
            var tmp = get_centered(view_1);
            // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_2 = new (RadioButton())(view_1.pc());
            var tmp0_elvis_lhs_2 = view_1.cbb_1;
            var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
            view_1.ebb(p_2, view_2);
            view_2.xah(view_2.nc7_1, equalTo(selectedKind, kind));
            view_1.fbb(p_2, view_2);
            view_1.jbb(tmp, view_2);
            var tmp_0 = view_1.ibb(view_1.ibb(get_expanding(view_1), get_compact(view_1)), get_compact(view_1));
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_3 = new (RowOrCol())(view_1.pc());
            var tmp0_elvis_lhs_3 = view_1.cbb_1;
            var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
            view_1.ebb(p_3, view_3);
            view_3.xbm(true);
            body(view_3, kind.khj_1);
            smallBody(view_3, kind.lhj_1);
            view_1.fbb(p_3, view_3);
            view_1.jbb(tmp_0, view_3);
            view_0.fbb(p_1, view_1);
          }
          view.fbb(p_0, view_0);
          var selectedWorkItem = Signal().fak(null);
          var tmp_1 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(selectedKind).equals(CreditKind_WorkItem_getInstance()));
          // Inline function 'com.crowpay.views.components.requiredField' call
          var label = 'Work Item';
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_4 = view.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
          view.ebb(p_4, view_4);
          view_4.xbm(true);
          view_4.zb8(get_AppDimensions().ng2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RowOrCol())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.ebb(p_5, view_5);
          view_5.xbm(false);
          view_5.zb8(get_AppDimensions().pg2_1);
          view_5.jbb(get_centered(view_5), bodyBold(view_5, label));
          view_5.jbb(colored(view_5, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_5, '*'));
          view_4.fbb(p_5, view_5);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_2 = view_4.hbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (Select())(view_4.pc());
          var tmp0_elvis_lhs_6 = view_4.cbb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
          view_4.ebb(p_6, view_6);
          var tmp_3 = remember(VOID, VOID, VOID, ($this$remember) => {
            var tmp = listOf(null);
            // Inline function 'kotlin.collections.map' call
            var this_0 = $this$remember.baj(this.xhj_1.tgm());
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.m1();
            while (_iterator__ex2g4s.n1()) {
              var item = _iterator__ex2g4s.o1();
              var tmp$ret$20 = item.hf9_1;
              destination.v(tmp$ret$20);
            }
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination_0 = ArrayList().w();
            var _iterator__ex2g4s_0 = destination.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (element.w91()) {
                destination_0.v(element);
              }
            }
            return plus(tmp, destination_0);
          });
          view_6.mcf(selectedWorkItem, tmp_3, draws$slambda$lambda$lambda);
          view_4.fbb(p_6, view_6);
          view_4.jbb(tmp_2, view_6);
          view.fbb(p_4, view_4);
          view.jbb(tmp_1, view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (Space())(view.pc(), 0.5);
          var tmp0_elvis_lhs_7 = view.cbb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
          view.ebb(p_7, view_7);
          view.fbb(p_7, view_7);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_8 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_8 = view.cbb_1;
          var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
          view.ebb(p_8, view_8);
          view_8.xbm(false);
          view_8.zb8(get_AppDimensions().jg2_1);
          var tmp_4 = get_primaryButton(view_8);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_9 = new (Button())(view_8.pc());
          var tmp0_elvis_lhs_9 = view_8.cbb_1;
          var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
          view_8.ebb(p_9, view_9);
          var tmp_5 = KMutableProperty0();
          var tmp_6 = Button$_get_enabled_$ref_61t7nx_0(view_9);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_5, tmp_6, Button$_set_enabled_$ref_o8kynz_0(view_9));
          reactiveScope(view_9, ($this$reactiveScope) => {
            var tmp;
            switch ($this$reactiveScope.baj(selectedKind).b4_1) {
              case 0:
                tmp = true;
                break;
              case 1:
                tmp = !($this$reactiveScope.baj(selectedWorkItem) == null);
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            var tmp$ret$38 = tmp;
            this_0.set(tmp$ret$38);
            return Unit_instance;
          });
          specCenteredText_0(view_9, ($this$specCenteredText) => {
            var tmp;
            switch ($this$specCenteredText.baj(selectedKind).b4_1) {
              case 0:
                tmp = 'Issue Project Credit';
                break;
              case 1:
                tmp = 'Issue Work Item Credit';
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            return tmp;
          });
          onClick(view_9, VOID, VOID, draws$slambda$lambda$slambda_0(selectedKind, this.xhj_1, selectedWorkItem));
          view_8.fbb(p_9, view_9);
          view_8.jbb(tmp_4, view_9);
          var tmp_7 = get_textButton(view_8);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_10 = new (Button())(view_8.pc());
          var tmp0_elvis_lhs_10 = view_8.cbb_1;
          var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
          view_8.ebb(p_10, view_10);
          specCenteredText(view_10, 'Go Back');
          onClick(view_10, VOID, VOID, draws$slambda$lambda$slambda_2(close));
          view_8.fbb(p_10, view_10);
          view_8.jbb(tmp_7, view_10);
          view.fbb(p_8, view_8);
          $this$dialog.fbb(p, view);
          return view;
        });
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    draws$slambdaClass = $;
  }
  return draws$slambdaClass;
}
function draws$slambda_0($this_draws) {
  var i = new (draws$slambda())($this_draws);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.yhj_1.dgt();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0 = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.m6y_1 == null) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_safe_receiver = tmp$ret$2;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    get_pageNavigator($this.zhj_1).dbw(new (PayAppForm())(tmp0_safe_receiver.i6y_1));
    tmp_0 = Unit_instance;
  }
  if (tmp_0 == null) {
    var tmp_1 = get_pageNavigator($this.zhj_1);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.yhj_1.jfy();
    var tmp_2 = await_0(this_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp$ret$5 = tmp_2;
    var tmp_3 = CreatePayApp(tmp$ret$5.x7a_1, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_1.dbw(tmp_3);
  }
  return Unit_instance;
}
var draws$slambdaClass_0;
function draws$slambda_1() {
  if (draws$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_draws, $$this$button) {
        this.yhj_1 = $this_draws;
        this.zhj_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    draws$slambdaClass_0 = $;
  }
  return draws$slambdaClass_0;
}
function draws$slambda_2($this_draws, $$this$button) {
  var i = new (draws$slambda_1())($this_draws, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.ahk_1 = function_0;
      }
      wi(a, b) {
        return this.ahk_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ahk_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function draws$lambda$lambda(a, b) {
  _init_properties_payAppsTab_kt__q3ukvv();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.b95();
  var tmp$ret$1 = b.b95();
  return compareValues(tmp, tmp$ret$1);
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = get_mainPageNavigator($this.bhk_1);
  var tmp_0 = renderCredit$_anonymous_$destination_vf59zy($this.chk_1, $this.dhk_1, $this.ehk_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.dbw(tmp_0);
  return Unit_instance;
}
var renderCredit$slambdaClass;
function renderCredit$slambda() {
  if (renderCredit$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, $credit, $this_renderCredit, $workItem) {
        this.bhk_1 = $$this$button;
        this.chk_1 = $credit;
        this.dhk_1 = $this_renderCredit;
        this.ehk_1 = $workItem;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderCredit$slambdaClass = $;
  }
  return renderCredit$slambdaClass;
}
function renderCredit$slambda_0($$this$button, $credit, $this_renderCredit, $workItem) {
  var i = new (renderCredit$slambda())($$this$button, $credit, $this_renderCredit, $workItem);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = get_dialogStack();
  var tmp_0 = renderCredit$_anonymous_$destination_vf59zy($this.fhk_1, $this.ghk_1, $this.hhk_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.xgd(tmp_0);
  return Unit_instance;
}
var renderCredit$slambdaClass_0;
function renderCredit$slambda_1() {
  if (renderCredit$slambdaClass_0 === VOID) {
    class $ {
      constructor($credit, $this_renderCredit, $workItem) {
        this.fhk_1 = $credit;
        this.ghk_1 = $this_renderCredit;
        this.hhk_1 = $workItem;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderCredit$slambdaClass_0 = $;
  }
  return renderCredit$slambdaClass_0;
}
function renderCredit$slambda_2($credit, $this_renderCredit, $workItem) {
  var i = new (renderCredit$slambda_1())($credit, $this_renderCredit, $workItem);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.ihk_1 = function_0;
      }
      wi(a, b) {
        return this.ihk_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ihk_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function renderPayApp2$lambda$lambda(a, b) {
  _init_properties_payAppsTab_kt__q3ukvv();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = a.af_1;
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k7z_1;
  var tmp0_safe_receiver_0 = b.af_1;
  var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.k7z_1;
  return compareValues(tmp, tmp$ret$1);
}
function *_generator_invoke__zhh2q8_3($this, $this$withWrite, it, $completion) {
  if (it) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.khk_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    // Inline function 'kotlin.collections.map' call
    var this_1 = tmp;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$1 = item.rhc_1.kf9_1;
      destination.v(tmp$ret$1);
    }
    $this.jhk_1.mam(toSet(destination));
  } else {
    $this.jhk_1.mam(emptySet());
  }
  return Unit_instance;
}
var renderPayApp2$slambdaClass;
function renderPayApp2$slambda() {
  if (renderPayApp2$slambdaClass === VOID) {
    class $ {
      constructor($selectedItems, $pending) {
        this.jhk_1 = $selectedItems;
        this.khk_1 = $pending;
      }
      afz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    renderPayApp2$slambdaClass = $;
  }
  return renderPayApp2$slambdaClass;
}
function renderPayApp2$slambda_0($selectedItems, $pending) {
  var i = new (renderPayApp2$slambda())($selectedItems, $pending);
  var l = ($this$withWrite, it, $completion) => i.afz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
var _no_name_provided__qut3ivClass;
function _no_name_provided__qut3iv() {
  if (_no_name_provided__qut3ivClass === VOID) {
    class $ {
      fd1(theme) {
        return theme.db1(SectionSemantic_getInstance()).eb1_1.zb0_1;
      }
    }
    protoOf($).ybe = plus_0;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    _no_name_provided__qut3ivClass = $;
  }
  return _no_name_provided__qut3ivClass;
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderPayApp2$lambda($this$specCenteredText) {
  _init_properties_payAppsTab_kt__q3ukvv();
  return 'View Details';
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lhk_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.mhk_1.jfy();
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.mhk_1.lgy();
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.nhk_1;
  var tmp_6 = await_0(this_3, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp$ret$3 = tmp_6;
  tmp.xgd(new (PayAppSummary())(tmp_1, tmp_3, tmp_5, tmp$ret$3));
  return Unit_instance;
}
var renderPayApp2$slambdaClass_0;
function renderPayApp2$slambda_1() {
  if (renderPayApp2$slambdaClass_0 === VOID) {
    class $ {
      constructor($payApp, $this_renderPayApp2, $items) {
        this.lhk_1 = $payApp;
        this.mhk_1 = $this_renderPayApp2;
        this.nhk_1 = $items;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPayApp2$slambdaClass_0 = $;
  }
  return renderPayApp2$slambdaClass_0;
}
function renderPayApp2$slambda_2($payApp, $this_renderPayApp2, $items) {
  var i = new (renderPayApp2$slambda_1())($payApp, $this_renderPayApp2, $items);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_5($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.afw_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.ohk_1;
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$1 = tmp_1;
    var tmp_2 = tmp_0.kft(tmp$ret$1.i6y_1).iem($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var renderPayApp2$slambda$slambdaClass;
function renderPayApp2$slambda$slambda() {
  if (renderPayApp2$slambda$slambdaClass === VOID) {
    class $ {
      constructor($payApp) {
        this.ohk_1 = $payApp;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPayApp2$slambda$slambdaClass = $;
  }
  return renderPayApp2$slambda$slambdaClass;
}
function renderPayApp2$slambda$slambda_0($payApp) {
  var i = new (renderPayApp2$slambda$slambda())($payApp);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var renderPayApp2$slambdaClass_1;
function renderPayApp2$slambda_3() {
  if (renderPayApp2$slambdaClass_1 === VOID) {
    class $ {
      constructor($payApp) {
        this.phk_1 = $payApp;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())('Delete Draft?', 'You are about to delete this draw draft. Deleted drafts cannot be recovered. Delete this draft?', VOID, 'Delete Draft', VOID, tmp_0, VOID, VOID, VOID, VOID, renderPayApp2$slambda$slambda_0(this.phk_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPayApp2$slambdaClass_1 = $;
  }
  return renderPayApp2$slambdaClass_1;
}
function renderPayApp2$slambda_4($payApp) {
  var i = new (renderPayApp2$slambda_3())($payApp);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderPayApp2$lambda$lambda$lambda(it) {
  _init_properties_payAppsTab_kt__q3ukvv();
  return it.o6y_1;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_shown_$ref_js8irt(p0) {
  return () => p0.wb8();
}
function IconView$_set_shown_$ref_9ilxmr(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderPayApp2$lambda$lambda$lambda$lambda(it) {
  _init_properties_payAppsTab_kt__q3ukvv();
  return it.shc_1;
}
function RowOrCol$_get_visible_$ref_m9hbzh(p0) {
  return () => p0.yb8();
}
function RowOrCol$_set_visible_$ref_80wucf(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_8(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_8(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function IconView$_get_source_$ref_hlcyij(p0) {
  return () => p0.obt_1;
}
function IconView$_set_source_$ref_2j4ddb(p0) {
  return (_this__u8e3s4) => {
    p0.qbt(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_6($this, $this$launch, $completion) {
  if ($this.qhk_1.rgj().equals(ProjectLens_Customer_getInstance())) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.shk_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    // Inline function 'kotlin.collections.map' call
    var this_1 = tmp;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$1 = item.rhc_1.kf9_1;
      destination.v(tmp$ret$1);
    }
    var tmp_0 = $this.rhk_1.gah(toSet(destination), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  var tmp_1 = JumpTo_getInstance().tg3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.thk_1;
  var tmp_2 = await_0(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2.i6y_1;
  tmp_1.xg4(tmp_3, $this.uhk_1, VOID, () => {
    $this.vhk_1.mam(true);
    return Unit_instance;
  });
  return Unit_instance;
}
var renderPayApp2$slambdaClass_2;
function renderPayApp2$slambda_5() {
  if (renderPayApp2$slambdaClass_2 === VOID) {
    class $ {
      constructor($this_renderPayApp2, $selectedItems, $pending, $payApp, $$this$table, $expanded) {
        this.qhk_1 = $this_renderPayApp2;
        this.rhk_1 = $selectedItems;
        this.shk_1 = $pending;
        this.thk_1 = $payApp;
        this.uhk_1 = $$this$table;
        this.vhk_1 = $expanded;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPayApp2$slambdaClass_2 = $;
  }
  return renderPayApp2$slambdaClass_2;
}
function renderPayApp2$slambda_6($this_renderPayApp2, $selectedItems, $pending, $payApp, $$this$table, $expanded) {
  var i = new (renderPayApp2$slambda_5())($this_renderPayApp2, $selectedItems, $pending, $payApp, $$this$table, $expanded);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.whk_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var items = tmp;
  var tmp_0 = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.xhk_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = element.shc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  var tmp_3 = destination;
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(items, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_0 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_0 = items.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element_0.rhc_1.kf9_1, element_0.rhc_1);
    destination_0.s3(pair.af_1, pair.bf_1);
  }
  var tmp_4 = destination_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.yhk_1.wgk();
  var tmp_5 = await_0(this_2, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = tmp_5.f5c_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.yhk_1.fgl();
  var tmp_7 = await_0(this_3, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp$ret$14 = tmp_7;
  tmp_0.xgd(new (DrawWaitedDetails())(tmp_2, tmp_3, tmp_4, tmp_6, tmp$ret$14.x5i_1));
  return Unit_instance;
}
var renderPayApp2$slambdaClass_3;
function renderPayApp2$slambda_7() {
  if (renderPayApp2$slambdaClass_3 === VOID) {
    class $ {
      constructor($items, $payApp, $this_renderPayApp2) {
        this.whk_1 = $items;
        this.xhk_1 = $payApp;
        this.yhk_1 = $this_renderPayApp2;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPayApp2$slambdaClass_3 = $;
  }
  return renderPayApp2$slambdaClass_3;
}
function renderPayApp2$slambda_8($items, $payApp, $this_renderPayApp2) {
  var i = new (renderPayApp2$slambda_7())($items, $payApp, $this_renderPayApp2);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $this$launch, $completion) {
  var tmp = $this.zhk_1.ofn($this.ahl_1.q6v_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  $this.bhl_1.bfw_1.bft(result);
  return Unit_instance;
}
var renderPayApp2$slambda$slambda$slambda$slambdaClass;
function renderPayApp2$slambda$slambda$slambda$slambda() {
  if (renderPayApp2$slambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($endpoints, $it, $session) {
        this.zhk_1 = $endpoints;
        this.ahl_1 = $it;
        this.bhl_1 = $session;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPayApp2$slambda$slambda$slambda$slambdaClass = $;
  }
  return renderPayApp2$slambda$slambda$slambda$slambdaClass;
}
function renderPayApp2$slambda$slambda$slambda$slambda_0($endpoints, $it, $session) {
  var i = new (renderPayApp2$slambda$slambda$slambda$slambda())($endpoints, $it, $session);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.chl_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var payItems = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_session();
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var session = tmp_0;
    var endpoints = session.tfw().kfg_1;
    var tmp_1 = coroutineScope(renderPayApp2$slambda$slambda$slambda_0(payItems, endpoints, session), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
var renderPayApp2$slambda$slambda$slambdaClass;
function renderPayApp2$slambda$slambda$slambda() {
  if (renderPayApp2$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($payItems, $endpoints, $session) {
        this.dhl_1 = $payItems;
        this.ehl_1 = $endpoints;
        this.fhl_1 = $session;
      }
      wah($this$coroutineScope, $completion) {
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = this.dhl_1;
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().w();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = element.shc_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.v(tmp0_safe_receiver);
          }
        }
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList().w();
        var _iterator__ex2g4s_0 = destination.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          if (get_status(element_0).equals(PayAppStatus_Pending_getInstance())) {
            destination_0.v(element_0);
          }
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_1 = destination_0.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          launch($this$coroutineScope, VOID, VOID, renderPayApp2$slambda$slambda$slambda$slambda_0(this.ehl_1, element_1, this.fhl_1));
        }
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPayApp2$slambda$slambda$slambdaClass = $;
  }
  return renderPayApp2$slambda$slambda$slambdaClass;
}
function renderPayApp2$slambda$slambda$slambda_0($payItems, $endpoints, $session) {
  var i = new (renderPayApp2$slambda$slambda$slambda())($payItems, $endpoints, $session);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var renderPayApp2$slambda$slambdaClass_0;
function renderPayApp2$slambda$slambda_1() {
  if (renderPayApp2$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($items) {
        this.chl_1 = $items;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPayApp2$slambda$slambdaClass_0 = $;
  }
  return renderPayApp2$slambda$slambdaClass_0;
}
function renderPayApp2$slambda$slambda_2($items) {
  var i = new (renderPayApp2$slambda$slambda_1())($items);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var renderPayApp2$slambdaClass_4;
function renderPayApp2$slambda_9() {
  if (renderPayApp2$slambdaClass_4 === VOID) {
    class $ {
      constructor($items) {
        this.ghl_1 = $items;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())('Void Draw', 'Are you sure you want to void the remaining draw items in this draw? This cannot be undone.', VOID, 'Void', VOID, tmp_0, VOID, VOID, VOID, VOID, renderPayApp2$slambda$slambda_2(this.ghl_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPayApp2$slambdaClass_4 = $;
  }
  return renderPayApp2$slambdaClass_4;
}
function renderPayApp2$slambda_10($items) {
  var i = new (renderPayApp2$slambda_9())($items);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return () => p0.wb8();
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_10($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this.hhl_1;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = element.shc_1;
      var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6v_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver_0);
      }
    }
    var payItems = destination;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.tfw().kfg_1.mfn(payItems, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$8 = emptySet();
    var tmp_1 = $this.ihl_1.gah(tmp$ret$8, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.jhl_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.khl_1;
    var tmp_0 = await_1(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    if (tmp_0.t1(element.rhc_1.kf9_1)) {
      destination.v(element);
    }
  }
  var selected = destination;
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.p91(0n);
  var _iterator__ex2g4s_0 = selected.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp_1 = sum;
    var tmp0_elvis_lhs = element_0.yhc_1;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) == null) {
      tmp_2 = Companion_instance.p91(0n);
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    var tmp$ret$5 = tmp_2;
    sum = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$5);
  }
  var total = sum;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.lhl_1.jfy();
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$7 = tmp_4;
  var retention = MonetaryValue__times_impl_hlr6p7(total, tmp$ret$7.u97());
  var totalMinusRetention = MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp(total, retention));
  var tmp_5 = get_dialogStack();
  var tmp_6;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.mhl_1;
  var tmp_7 = await_0(this_3, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  if (tmp_7) {
    tmp_6 = 'Pay Draw';
  } else {
    tmp_6 = 'Pay ' + selected.p1() + ' Draw Items';
  }
  var tmp_8 = tmp_6;
  var tmp_9 = 'Pay ' + totalMinusRetention + ' out of escrow to contractor?';
  var tmp_10 = 'Pay ' + totalMinusRetention;
  tmp_5.xgd(new (GenericConfirmationDialog())(tmp_8, tmp_9, VOID, tmp_10, VOID, VOID, VOID, VOID, VOID, 'DRAW SIGN-OFF', renderPayApp2$slambda$slambda_4(selected, $this.khl_1)));
  return Unit_instance;
}
var renderPayApp2$slambda$slambdaClass_1;
function renderPayApp2$slambda$slambda_3() {
  if (renderPayApp2$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($selected, $selectedItems) {
        this.hhl_1 = $selected;
        this.ihl_1 = $selectedItems;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPayApp2$slambda$slambdaClass_1 = $;
  }
  return renderPayApp2$slambda$slambdaClass_1;
}
function renderPayApp2$slambda$slambda_4($selected, $selectedItems) {
  var i = new (renderPayApp2$slambda$slambda_3())($selected, $selectedItems);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var renderPayApp2$slambdaClass_5;
function renderPayApp2$slambda_11() {
  if (renderPayApp2$slambdaClass_5 === VOID) {
    class $ {
      constructor($pending, $selectedItems, $this_renderPayApp2, $allSelected) {
        this.jhl_1 = $pending;
        this.khl_1 = $selectedItems;
        this.lhl_1 = $this_renderPayApp2;
        this.mhl_1 = $allSelected;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPayApp2$slambdaClass_5 = $;
  }
  return renderPayApp2$slambdaClass_5;
}
function renderPayApp2$slambda_12($pending, $selectedItems, $this_renderPayApp2, $allSelected) {
  var i = new (renderPayApp2$slambda_11())($pending, $selectedItems, $this_renderPayApp2, $allSelected);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_shown_$ref_hkylj1_0(p0) {
  return () => p0.wb8();
}
function Button$_set_shown_$ref_bpvuvj_0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_12($this, value, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.nhl_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filterNot' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterNotTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (!element.equals(value)) {
      destination.v(element);
    }
  }
  var tmp_0 = $this.nhl_1.gah(toSet(destination), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ohl_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.phl_1;
    var tmp_0 = await_1(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    if (tmp_0.t1(element.rhc_1.kf9_1)) {
      destination.v(element);
    }
  }
  var selected = destination;
  var tmp_1 = get_dialogStack();
  var tmp_2 = toList(selected);
  tmp_1.xgd(WaitDrawsDialog(tmp_2, renderPayApp2$slambda$slambda_6($this.phl_1)));
  return Unit_instance;
}
var renderPayApp2$slambda$slambdaClass_2;
function renderPayApp2$slambda$slambda_5() {
  if (renderPayApp2$slambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($selectedItems) {
        this.nhl_1 = $selectedItems;
      }
      lhf(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, value), $completion);
      }
      s2(p1, $completion) {
        return this.lhf(p1 instanceof UUID() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPayApp2$slambda$slambdaClass_2 = $;
  }
  return renderPayApp2$slambda$slambdaClass_2;
}
function renderPayApp2$slambda$slambda_6($selectedItems) {
  var i = new (renderPayApp2$slambda$slambda_5())($selectedItems);
  var l = (value, $completion) => i.lhf(value, $completion);
  l.$arity = 1;
  return l;
}
var renderPayApp2$slambdaClass_6;
function renderPayApp2$slambda_13() {
  if (renderPayApp2$slambdaClass_6 === VOID) {
    class $ {
      constructor($pending, $selectedItems) {
        this.ohl_1 = $pending;
        this.phl_1 = $selectedItems;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPayApp2$slambdaClass_6 = $;
  }
  return renderPayApp2$slambdaClass_6;
}
function renderPayApp2$slambda_14($pending, $selectedItems) {
  var i = new (renderPayApp2$slambda_13())($pending, $selectedItems);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_9(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_9(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_10(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_10(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_11(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_11(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function CreditKind_Project_getInstance() {
  CreditKind_initEntries();
  return CreditKind_Project_instance;
}
function CreditKind_WorkItem_getInstance() {
  CreditKind_initEntries();
  return CreditKind_WorkItem_instance;
}
var properties_initialized_payAppsTab_kt_e23o3h;
function _init_properties_payAppsTab_kt__q3ukvv() {
  if (!properties_initialized_payAppsTab_kt_e23o3h) {
    properties_initialized_payAppsTab_kt_e23o3h = true;
    rowHeight = get_rem_0(3.5);
  }
}
//region block: exports
export {
  draws as draws35jr59nzlfey8,
};
//endregion

//# sourceMappingURL=payAppsTab.mjs.map
